import {BlockType} from "../components/Block";

export const Dirt: BlockType = {
    name: "dirt",
    image: "https://minecraft.wiki/images/Dirt.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "pre-classic",
    color: "brown"
}
export const Stone: BlockType = {
    name: "stone",
    image: "https://minecraft.wiki/images/Stone_JE8.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "pre-classic",
    color: "gray"
}
export const Glass: BlockType = {
    name: "glass",
    image: "https://minecraft.wiki/images/Glass_JE4_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "None",
    version: "classic",
    color: "none"
}
export const Gravel: BlockType = {
    name: "gravel",
    image: "https://minecraft.wiki/images/Gravel_JE5_BE4.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Shovel",
    version: "classic",
    color: "gray"
}
export const Sand: BlockType = {
    name: "sand",
    image: "https://minecraft.wiki/images/Sand_JE5_BE3.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "classic",
    color: "cream"
}
export const Melon: BlockType = {
    name: "melon",
    image: "https://minecraft.wiki/images/Melon_JE2_BE2.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "beta",
    color: "green"
}
export const Cobweb: BlockType = {
    name: "cobweb",
    image: "https://minecraft.wiki/images/Cobweb_JE5.png",
    hardness: 4,
    blast_resistance: 4,
    tool: "Shears",
    version: "beta",
    color: "white"
}
export const Diorite: BlockType = {
    name: "diorite",
    image: "https://minecraft.wiki/images/Diorite.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "white"
}
export const Andesite: BlockType = {
    name: "andesite",
    image: "https://minecraft.wiki/images/Andesite.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "gray"
}
export const AcaciaButton: BlockType = {
    name: "acacia_button",
    image: "https://minecraft.wiki/images/Acacia_Button_JE4.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.13",
    color: "orange"
}
export const AcaciaDoor: BlockType = {
    name: "acacia_door",
    image: "https://minecraft.wiki/images/Acacia_Door_JE5.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "orange"
}
export const AcaciaFence: BlockType = {
    name: "acacia_fence",
    image: "https://minecraft.wiki/images/Acacia_Fence_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "orange"
}
export const AcaciaFenceGate: BlockType = {
    name: "acacia_fence_gate",
    image: "https://minecraft.wiki/images/Acacia_Fence_Gate_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "orange"
}
export const AcaciaHangingSign: BlockType = {
    name: "acacia_hanging_sign",
    image: "https://minecraft.wiki/images/Acacia_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "orange"
}
export const AcaciaLeaves: BlockType = {
    name: "acacia_leaves",
    image: "https://minecraft.wiki/images/Acacia_Leaves.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "1.7.2",
    color: "green"
}
export const AcaciaLog: BlockType = {
    name: "acacia_log",
    image: "https://minecraft.wiki/images/Acacia_Log.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.7.2",
    color: "orange"
}
export const AcaciaPlanks: BlockType = {
    name: "acacia_planks",
    image: "https://minecraft.wiki/images/Acacia_Planks.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.7.2",
    color: "orange"
}
export const AcaciaPressurePlate: BlockType = {
    name: "acacia_pressure_plate",
    image: "https://minecraft.wiki/images/Acacia_Pressure_Plate_JE3_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.13",
    color: "orange"
}
export const AcaciaSapling: BlockType = {
    name: "acacia_sapling",
    image: "https://minecraft.wiki/images/Acacia_Sapling_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "green"
}
export const AcaciaSign: BlockType = {
    name: "acacia_sign",
    image: "https://minecraft.wiki/images/Acacia_Sign_(0).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.14",
    color: "orange"
}
export const AcaciaSlab: BlockType = {
    name: "acacia_slab",
    image: "https://minecraft.wiki/images/Acacia_Slab.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.7.2",
    color: "orange"
}
export const AcaciaStairs: BlockType = {
    name: "acacia_stairs",
    image: "https://minecraft.wiki/images/Acacia_Stairs.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.7.2",
    color: "orange"
}
export const AcaciaTrapdoor: BlockType = {
    name: "acacia_trapdoor",
    image: "https://minecraft.wiki/images/Acacia_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.13",
    color: "orange"
}
export const AcaciaWood: BlockType = {
    name: "acacia_wood",
    image: "https://minecraft.wiki/images/Acacia_Wood.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "gray"
}
export const ActivatorRail: BlockType = {
    name: "activator_rail",
    image: "https://minecraft.wiki/images/Activator_Rail_(NS)_JE2_BE2.png",
    hardness: 0.7,
    blast_resistance: 0.7,
    tool: "Pickaxe",
    version: "1.5",
    color: "red"
}
export const Allium: BlockType = {
    name: "allium",
    image: "https://minecraft.wiki/images/Allium_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "magenta"
}
export const AmethystCluster: BlockType = {
    name: "amethyst_cluster",
    image: "https://minecraft.wiki/images/Amethyst_Cluster_(U)_JE1.png",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Pickaxe",
    version: "1.17",
    color: "purple"
}
export const AncientDebris: BlockType = {
    name: "ancient_debris",
    image: "https://minecraft.wiki/images/Ancient_Debris_JE1_BE1.png",
    hardness: 30,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "1.16",
    color: "brown"
}
export const AndesiteSlab: BlockType = {
    name: "andesite_slab",
    image: "https://minecraft.wiki/images/Andesite_Slab_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const AndesiteStairs: BlockType = {
    name: "andesite_stairs",
    image: "https://minecraft.wiki/images/Andesite_Stairs_(N)_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const AndesiteWall: BlockType = {
    name: "andesite_wall",
    image: "https://minecraft.wiki/images/Andesite_Wall_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const Anvil: BlockType = {
    name: "anvil",
    image: "https://minecraft.wiki/images/Anvil_(N)_JE3.png",
    hardness: 5,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "1.4.2",
    color: "gray"
}
export const Azalea: BlockType = {
    name: "azalea",
    image: "https://minecraft.wiki/images/Azalea_JE2_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.17",
    color: "green"
}
export const Leaves: BlockType = {
    name: "leaves",
    image: "https://minecraft.wiki/images/Azalea_Leaves.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "1.17",
    color: "green"
}
export const AzureBluet: BlockType = {
    name: "azure_bluet",
    image: "https://minecraft.wiki/images/Azure_Bluet_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "white"
}
export const Bamboo: BlockType = {
    name: "bamboo",
    image: "https://minecraft.wiki/images/Leafless_Bamboo_JE1_BE2.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.14",
    color: "green"
}
export const BambooButton: BlockType = {
    name: "bamboo_button",
    image: "https://minecraft.wiki/images/Bamboo_Button_JE3.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.19.3",
    color: "yellow"
}
export const BambooDoor: BlockType = {
    name: "bamboo_door",
    image: "https://minecraft.wiki/images/Bamboo_Door_JE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooFence: BlockType = {
    name: "bamboo_fence",
    image: "https://minecraft.wiki/images/Bamboo_Fence_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooFenceGate: BlockType = {
    name: "bamboo_fence_gate",
    image: "https://minecraft.wiki/images/Bamboo_Fence_Gate_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooHangingSign: BlockType = {
    name: "bamboo_hanging_sign",
    image: "https://minecraft.wiki/images/Bamboo_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooMosaic: BlockType = {
    name: "bamboo_mosaic",
    image: "https://minecraft.wiki/images/Bamboo_Mosaic_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooMosaicSlab: BlockType = {
    name: "bamboo_mosaic_slab",
    image: "https://minecraft.wiki/images/Bamboo_Mosaic_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooMosaicStairs: BlockType = {
    name: "bamboo_mosaic_stairs",
    image: "https://minecraft.wiki/images/Bamboo_Mosaic_Stairs_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooPlanks: BlockType = {
    name: "bamboo_planks",
    image: "https://minecraft.wiki/images/Bamboo_Planks_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooPressurePlate: BlockType = {
    name: "bamboo_pressure_plate",
    image: "https://minecraft.wiki/images/Bamboo_Pressure_Plate_JE2_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooSign: BlockType = {
    name: "sign",
    image: "https://minecraft.wiki/images/Bamboo_Sign_(0)_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooSlab: BlockType = {
    name: "bamboo_slab",
    image: "https://minecraft.wiki/images/Bamboo_Slab_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooStairs: BlockType = {
    name: "bamboo_stairs",
    image: "https://minecraft.wiki/images/Bamboo_Stairs_JE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BambooTrapdoor: BlockType = {
    name: "bamboo_trapdoor",
    image: "https://minecraft.wiki/images/Bamboo_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const Barrel: BlockType = {
    name: "barrel",
    image: "https://minecraft.wiki/images/Barrel_(U)_JE1_BE1.png",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "1.14",
    color: "brown"
}
export const Barrier: BlockType = {
    name: "barrier",
    image: "https://minecraft.wiki/images/Barrier_(held)_JE2_BE2.png",
    hardness: -1,
    blast_resistance: 3600000.8,
    tool: "None",
    version: "1.8",
    color: "none"
}
export const Basalt: BlockType = {
    name: "basalt",
    image: "https://minecraft.wiki/images/Basalt_(UD)_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.16",
    color: "gray"
}
export const Beacon: BlockType = {
    name: "beacon",
    image: "https://minecraft.wiki/images/Beacon_JE6_BE2.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Any",
    version: "1.4.2",
    color: "light_blue"
}
export const Bedrock: BlockType = {
    name: "bedrock",
    image: "https://minecraft.wiki/images/Bedrock_JE2_BE2.png",
    hardness: -1,
    blast_resistance: 3600000,
    tool: "None",
    version: "classic",
    color: "gray"
}
export const BeeNest: BlockType = {
    name: "bee_nest",
    image: "https://minecraft.wiki/images/Bee_Nest_(S)_JE1.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Axe",
    version: "1.15",
    color: "yellow"
}
export const Beehive: BlockType = {
    name: "beehive",
    image: "https://minecraft.wiki/images/Beehive_(S)_JE1.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Axe",
    version: "1.15",
    color: "light_brown"
}
export const BeetrootSeeds: BlockType = {
    name: "beetroot_seeds",
    image: "https://minecraft.wiki/images/Beetroots_Age_3_JE3.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.9",
    color: "red"
}
export const Bell: BlockType = {
    name: "bell",
    image: "https://minecraft.wiki/images/Bell_(N).png",
    hardness: 5,
    blast_resistance: 5,
    tool: "Pickaxe",
    version: "1.14",
    color: "yellow"
}
export const BigDripleaf: BlockType = {
    name: "big_dripleaf",
    image: "https://minecraft.wiki/images/Big_Dripleaf_JE2_BE1.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Axe",
    version: "1.17",
    color: "green"
}
export const BirchButton: BlockType = {
    name: "birch_button",
    image: "https://minecraft.wiki/images/Birch_Button_JE4.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.13",
    color: "cream"
}
export const BirchDoor: BlockType = {
    name: "birch_door",
    image: "https://minecraft.wiki/images/Birch_Door_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "cream"
}
export const BirchFence: BlockType = {
    name: "birch_fence",
    image: "https://minecraft.wiki/images/Birch_Fence_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "cream"
}
export const BirchFenceGate: BlockType = {
    name: "birch_fence_gate",
    image: "https://minecraft.wiki/images/Birch_Fence_Gate_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "cream"
}
export const BirchHangingSign: BlockType = {
    name: "birch_hanging_sign",
    image: "https://minecraft.wiki/images/Birch_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "cream"
}
export const BirchLeaves: BlockType = {
    name: "birch_leaves",
    image: "https://minecraft.wiki/images/Birch_Leaves_JE1_BE2.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "beta",
    color: "green"
}
export const BirchLog: BlockType = {
    name: "birch_log",
    image: "https://minecraft.wiki/images/Birch_Log_(UD)_JE5_BE3.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "beta",
    color: "white"
}
export const BirchPlanks: BlockType = {
    name: "birch_planks",
    image: "https://minecraft.wiki/images/Birch_Planks_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.2.4",
    color: "cream"
}
export const BirchPressurePlate: BlockType = {
    name: "birch_pressure_plate",
    image: "https://minecraft.wiki/images/Birch_Pressure_Plate_JE3_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.13",
    color: "cream"
}
export const BirchSapling: BlockType = {
    name: "birch_sapling",
    image: "https://minecraft.wiki/images/Birch_Sapling_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "beta",
    color: "green"
}
export const BirchSign: BlockType = {
    name: "birch_sign",
    image: "https://minecraft.wiki/images/Birch_Standing_Sign_(S)_JE2_BE2.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.14",
    color: "cream"
}
export const BirchSlab: BlockType = {
    name: "birch_slab",
    image: "https://minecraft.wiki/images/Birch_Slab_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.3.1",
    color: "cream"
}
export const BirchStairs: BlockType = {
    name: "birch_stairs",
    image: "https://minecraft.wiki/images/Birch_Stairs_(N)_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.3.1",
    color: "cream"
}
export const BirchTrapdoor: BlockType = {
    name: "birch_trapdoor",
    image: "https://minecraft.wiki/images/Birch_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.13",
    color: "cream"
}
export const BirchWood: BlockType = {
    name: "birch_wood",
    image: "https://minecraft.wiki/images/Birch_Wood_(UD)_JE4.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "white"
}
export const BlackBanner: BlockType = {
    name: "black_banner",
    image: "https://minecraft.wiki/images/Black_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "black"
}
export const BlackBed: BlockType = {
    name: "black_bed",
    image: "https://minecraft.wiki/images/Black_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "black"
}
export const BlackCandle: BlockType = {
    name: "black_candle",
    image: "https://minecraft.wiki/images/Black_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "black"
}
export const BlackCarpet: BlockType = {
    name: "black_carpet",
    image: "https://minecraft.wiki/images/Black_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "black"
}
export const BlackConcrete: BlockType = {
    name: "black_concrete",
    image: "https://minecraft.wiki/images/Black_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "black"
}
export const BlackConcretePowder: BlockType = {
    name: "black_concrete_powder",
    image: "https://minecraft.wiki/images/Black_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "black"
}
export const BlackGlazedTerracotta: BlockType = {
    name: "black_glazed_terracotta",
    image: "https://minecraft.wiki/images/Black_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "black"
}
export const BlackShulkerBox: BlockType = {
    name: "black_shulker_box",
    image: "https://minecraft.wiki/images/Black_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "black"
}
export const BlackStainedGlass: BlockType = {
    name: "black_stained_glass",
    image: "https://minecraft.wiki/images/Black_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "black"
}
export const BlackStainedGlassPane: BlockType = {
    name: "black_stained_glass_pane",
    image: "https://minecraft.wiki/images/Black_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "black"
}
export const BlackStainedTerracotta: BlockType = {
    name: "black_stained_terracotta",
    image: "https://minecraft.wiki/images/Black_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "black"
}
export const BlackWool: BlockType = {
    name: "black_wool",
    image: "https://minecraft.wiki/images/Black_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "black"
}
export const Blackstone: BlockType = {
    name: "blackstone",
    image: "https://minecraft.wiki/images/Blackstone_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const BlackstoneSlab: BlockType = {
    name: "blackstone_slab",
    image: "https://minecraft.wiki/images/Blackstone_Slab_JE3.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const BlackstoneStairs: BlockType = {
    name: "blackstone_stairs",
    image: "https://minecraft.wiki/images/Blackstone_Stairs_JE3.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const BlackstoneWall: BlockType = {
    name: "blackstone_wall",
    image: "https://minecraft.wiki/images/Blackstone_Wall_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const BlastFurnace: BlockType = {
    name: "blast_furnace",
    image: "https://minecraft.wiki/images/Blast_Furnace_(S)_JE1.png",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const BlockofAmethyst: BlockType = {
    name: "block_of_amethyst",
    image: "https://minecraft.wiki/images/Block_of_Amethyst_JE3_BE1.png",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Pickaxe",
    version: "1.17",
    color: "purple"
}
export const BlockofBamboo: BlockType = {
    name: "block_of_bamboo",
    image: "https://minecraft.wiki/images/Block_of_Bamboo_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.19.3",
    color: "green"
}
export const BlockofCoal: BlockType = {
    name: "block_of_coal",
    image: "https://minecraft.wiki/images/Block_of_Coal_JE3_BE2.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "black"
}
export const BlockofCopper: BlockType = {
    name: "block_of_copper",
    image: "https://minecraft.wiki/images/Copper_Block_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "orange"
}
export const BlockofDiamond: BlockType = {
    name: "block_of_diamond",
    image: "https://minecraft.wiki/images/Block_of_Diamond_JE5_BE3.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "indev",
    color: "light_blue"
}
export const BlockofEmerald: BlockType = {
    name: "block_of_emerald",
    image: "https://minecraft.wiki/images/Block_of_Emerald_JE4_BE3.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.3.1",
    color: "green"
}
export const BlockofGold: BlockType = {
    name: "block_of_gold",
    image: "https://minecraft.wiki/images/Block_of_Gold_JE6_BE3.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "classic",
    color: "yellow"
}
export const BlockofIron: BlockType = {
    name: "block_of_iron",
    image: "https://minecraft.wiki/images/Block_of_Iron_JE4_BE3.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "classic",
    color: "white"
}
export const BlockofLapisLazuli: BlockType = {
    name: "block_of_lapis_lazuli",
    image: "https://minecraft.wiki/images/Block_of_Lapis_Lazuli_JE3_BE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.2",
    color: "blue"
}
export const BlockofNetherite: BlockType = {
    name: "block_of_netherite",
    image: "https://minecraft.wiki/images/Block_of_Netherite_JE1_BE1.png",
    hardness: 50,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "1.16",
    color: "brown"
}
export const BlockofQuartz: BlockType = {
    name: "block_of_quartz",
    image: "https://minecraft.wiki/images/Block_of_Quartz_JE4_BE4.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.5",
    color: "white"
}
export const BlockofRawCopper: BlockType = {
    name: "block_of_raw_copper",
    image: "https://minecraft.wiki/images/Block_of_Raw_Copper_JE2_BE2.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "orange"
}
export const BlockofRawGold: BlockType = {
    name: "block_of_raw_gold",
    image: "https://minecraft.wiki/images/Block_of_Raw_Gold_JE3_BE2.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "yellow"
}
export const BlockofRawIron: BlockType = {
    name: "block_of_raw_iron",
    image: "https://minecraft.wiki/images/Block_of_Raw_Iron_JE3_BE2.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "light_brown"
}
export const BlockofRedstone: BlockType = {
    name: "block_of_redstone",
    image: "https://minecraft.wiki/images/Block_of_Redstone_JE2_BE2.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.5",
    color: "red"
}
export const BlockofResin: BlockType = {
    name: "block_of_resin",
    image: "https://minecraft.wiki/images/Block_of_Resin_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Pickaxe",
    version: "1.21.4",
    color: "orange"
}
export const BlockofStrippedBamboo: BlockType = {
    name: "block_of_stripped_bamboo",
    image: "https://minecraft.wiki/images/Block_of_Stripped_Bamboo_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.19.3",
    color: "yellow"
}
export const BlueBanner: BlockType = {
    name: "blue_banner",
    image: "https://minecraft.wiki/images/Blue_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "blue"
}
export const BlueBed: BlockType = {
    name: "blue_bed",
    image: "https://minecraft.wiki/images/Blue_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "blue"
}
export const BlueCandle: BlockType = {
    name: "blue_candle",
    image: "https://minecraft.wiki/images/Blue_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "blue"
}
export const BlueCarpet: BlockType = {
    name: "blue_carpet",
    image: "https://minecraft.wiki/images/Blue_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "blue"
}
export const BlueConcrete: BlockType = {
    name: "blue_concrete",
    image: "https://minecraft.wiki/images/Blue_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "blue"
}
export const BlueConcretePowder: BlockType = {
    name: "blue_concrete_powder",
    image: "https://minecraft.wiki/images/Blue_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "blue"
}
export const BlueGlazedTerracotta: BlockType = {
    name: "blue_glazed_terracotta",
    image: "https://minecraft.wiki/images/Blue_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "blue"
}
export const BlueIce: BlockType = {
    name: "blue_ice",
    image: "https://minecraft.wiki/images/Blue_Ice_JE3_BE2.png",
    hardness: 2.8,
    blast_resistance: 2.8,
    tool: "Pickaxe",
    version: "1.13",
    color: "light_blue"
}
export const BlueOrchid: BlockType = {
    name: "blue_orchid",
    image: "https://minecraft.wiki/images/Blue_Orchid_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "light_blue"
}
export const BlueShulkerBox: BlockType = {
    name: "blue_shulker_box",
    image: "https://minecraft.wiki/images/Blue_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "blue"
}
export const BlueStainedGlass: BlockType = {
    name: "blue_stained_glass",
    image: "https://minecraft.wiki/images/Blue_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "blue"
}
export const BlueStainedGlassPane: BlockType = {
    name: "blue_stained_glass_pane",
    image: "https://minecraft.wiki/images/Blue_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "blue"
}
export const BlueStainedTerracotta: BlockType = {
    name: "blue_stained_terracotta",
    image: "https://minecraft.wiki/images/Blue_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "purple"
}
export const BlueWool: BlockType = {
    name: "blue_wool",
    image: "https://minecraft.wiki/images/Blue_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "blue"
}
export const BoneBlock: BlockType = {
    name: "bone_block",
    image: "https://minecraft.wiki/images/Bone_Block_(UD)_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.10",
    color: "white"
}
export const Bookshelf: BlockType = {
    name: "bookshelf",
    image: "https://minecraft.wiki/images/Bookshelf_JE4_BE2.png",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Axe",
    version: "classic",
    color: "light_brown"
}
export const BrainCoral: BlockType = {
    name: "brain_coral",
    image: "https://minecraft.wiki/images/Brain_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "pink"
}
export const BrainCoralBlock: BlockType = {
    name: "brain_coral_block",
    image: "https://minecraft.wiki/images/Brain_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "pink"
}
export const BrainCoralFan: BlockType = {
    name: "brain_coral_fan",
    image: "https://minecraft.wiki/images/Brain_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "pink"
}
export const BrewingStand: BlockType = {
    name: "brewing_stand",
    image: "https://minecraft.wiki/images/Brewing_Stand_(empty)_JE10.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "1.0.0",
    color: "gray"
}
export const BrickSlab: BlockType = {
    name: "brick_slab",
    image: "https://minecraft.wiki/images/Brick_Slab_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "red"
}
export const BrickStairs: BlockType = {
    name: "brick_stairs",
    image: "https://minecraft.wiki/images/Brick_Stairs_(N)_JE5_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "red"
}
export const BrickWall: BlockType = {
    name: "brick_wall",
    image: "https://minecraft.wiki/images/Brick_Wall_JE1_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "red"
}
export const Bricks: BlockType = {
    name: "bricks",
    image: "https://minecraft.wiki/images/Bricks_JE5_BE3.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "classic",
    color: "red"
}
export const BrownBanner: BlockType = {
    name: "brown_banner",
    image: "https://minecraft.wiki/images/Brown_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "brown"
}
export const BrownBed: BlockType = {
    name: "brown_bed",
    image: "https://minecraft.wiki/images/Brown_Candle.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "brown"
}
export const BrownCandle: BlockType = {
    name: "brown_candle",
    image: "https://minecraft.wiki/images/Brown_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "brown"
}
export const BrownCarpet: BlockType = {
    name: "brown_carpet",
    image: "https://minecraft.wiki/images/Brown_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "brown"
}
export const BrownConcrete: BlockType = {
    name: "brown_concrete",
    image: "https://minecraft.wiki/images/Brown_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "brown"
}
export const BrownConcretePowder: BlockType = {
    name: "brown_concrete_powder",
    image: "https://minecraft.wiki/images/Brown_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "brown"
}
export const BrownGlazedTerracotta: BlockType = {
    name: "brown_glazed_terracotta",
    image: "https://minecraft.wiki/images/Brown_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "brown"
}
export const BrownMushroom: BlockType = {
    name: "brown_mushroom",
    image: "https://minecraft.wiki/images/Brown_Mushroom_JE9.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "classic",
    color: "brown"
}
export const BrownMushroomBlock: BlockType = {
    name: "brown_mushroom_block",
    image: "https://minecraft.wiki/images/Brown_Mushroom_Block_(ESU)_JE2_BE2.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Axe",
    version: "beta",
    color: "brown"
}
export const BrownShulkerBox: BlockType = {
    name: "brown_shulker_box",
    image: "https://minecraft.wiki/images/Brown_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "brown"
}
export const BrownStainedGlass: BlockType = {
    name: "brown_stained_glass",
    image: "https://minecraft.wiki/images/Brown_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "brown"
}
export const BrownStainedGlassPane: BlockType = {
    name: "brown_stained_glass_pane",
    image: "https://minecraft.wiki/images/Brown_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "brown"
}
export const BrownStainedTerracotta: BlockType = {
    name: "brown_stained_terracotta",
    image: "https://minecraft.wiki/images/Brown_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "brown"
}
export const BrownWool: BlockType = {
    name: "brown_wool",
    image: "https://minecraft.wiki/images/Brown_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "brown"
}
export const BubbleColumn: BlockType = {
    name: "bubble_column",
    image: "https://minecraft.wiki/images/Bubble_Column_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 100,
    tool: "None",
    version: "1.13",
    color: "none"
}
export const BubbleCoral: BlockType = {
    name: "bubble_coral",
    image: "https://minecraft.wiki/images/Bubble_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "purple"
}
export const BubbleCoralBlock: BlockType = {
    name: "bubble_coral_block",
    image: "https://minecraft.wiki/images/Bubble_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "purple"
}
export const BubbleCoralFan: BlockType = {
    name: "bubble_coral_fan",
    image: "https://minecraft.wiki/images/Bubble_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "purple"
}
export const BuddingAmethyst: BlockType = {
    name: "budding_amethyst",
    image: "https://minecraft.wiki/images/Budding_Amethyst_JE3_BE1.png",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Pickaxe",
    version: "1.17",
    color: "purple"
}
export const Cactus: BlockType = {
    name: "cactus",
    image: "https://minecraft.wiki/images/Cactus_JE4.png",
    hardness: 0.4,
    blast_resistance: 0.4,
    tool: "Any",
    version: "alpha",
    color: "green"
}
export const Cake: BlockType = {
    name: "cake",
    image: "https://minecraft.wiki/images/Cake_JE4.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "beta",
    color: "white"
}
export const Calcite: BlockType = {
    name: "calcite",
    image: "https://minecraft.wiki/images/Calcite_JE4_BE1.png",
    hardness: 0.75,
    blast_resistance: 0.75,
    tool: "Pickaxe",
    version: "1.17",
    color: "white"
}
export const CalibratedSculkSensor: BlockType = {
    name: "calibrated_sculk_sensor",
    image: "https://minecraft.wiki/images/Calibrated_Sculk_Sensor_JE2.gif",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Hoe",
    version: "1.17",
    color: "dark_blue"
}
export const Campfire: BlockType = {
    name: "campfire",
    image: "https://minecraft.wiki/images/Campfire_JE2_BE2.gif",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.14",
    color: "brown"
}
export const Candle: BlockType = {
    name: "candle",
    image: "https://minecraft.wiki/images/Candle_JE1_BE1.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "cream"
}
export const Carrots: BlockType = {
    name: "carrots",
    image: "https://minecraft.wiki/images/Carrots_Age_7_JE9.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "None",
    version: "1.4.2",
    color: "orange"
}
export const CartographyTable: BlockType = {
    name: "cartography_table",
    image: "https://minecraft.wiki/images/Cartography_Table_JE3_BE2.png",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "1.14",
    color: "dark_brown"
}
export const CarvedPumpkin: BlockType = {
    name: "carved_pumpkin",
    image: "https://minecraft.wiki/images/Carved_Pumpkin_(S)_JE5.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "alpha",
    color: "orange"
}
export const Cauldron: BlockType = {
    name: "cauldron",
    image: "https://minecraft.wiki/images/Cauldron_JE7.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.0.0",
    color: "gray"
}
export const GlowBerries: BlockType = {
    name: "glow_berries",
    image: "https://minecraft.wiki/images/Cave_Vines_(berries)_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.17",
    color: "green"
}
export const Chain: BlockType = {
    name: "chain",
    image: "https://minecraft.wiki/images/Chain_(UD)_JE1_BE1.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "gray"
}
export const ChainCommandBlock: BlockType = {
    name: "chain_command_block",
    image: "https://minecraft.wiki/images/Chain_Command_Block.gif",
    hardness: -1,
    blast_resistance: 3600000,
    tool: "None",
    version: "1.9",
    color: "light_blue"
}
export const Chest: BlockType = {
    name: "chest",
    image: "https://minecraft.wiki/images/Chest.gif",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "indev",
    color: "brown"
}
export const CherryButton: BlockType = {
    name: "cherry_button",
    image: "https://minecraft.wiki/images/Cherry_Button_JE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.19.4",
    color: "pink"
}
export const CherryDoor: BlockType = {
    name: "cherry_door",
    image: "https://minecraft.wiki/images/Cherry_Door_JE2_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryFence: BlockType = {
    name: "cherry_fence",
    image: "https://minecraft.wiki/images/Cherry_Fence_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryFenceGate: BlockType = {
    name: "cherry_fence_gate",
    image: "https://minecraft.wiki/images/Cherry_Fence_Gate_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryHangingSign: BlockType = {
    name: "cherry_hanging_sign",
    image: "https://minecraft.wiki/images/Cherry_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryLeaves: BlockType = {
    name: "cherry_leaves",
    image: "https://minecraft.wiki/images/Cherry_Leaves_JE2.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "1.19.4",
    color: "pink"
}
export const CherryLog: BlockType = {
    name: "cherry_log",
    image: "https://minecraft.wiki/images/Cherry_Log_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryPlanks: BlockType = {
    name: "cherry_planks",
    image: "https://minecraft.wiki/images/Cherry_Planks_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryPressurePlate: BlockType = {
    name: "cherry_pressure_plate",
    image: "https://minecraft.wiki/images/Cherry_Pressure_Plate_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherrySapling: BlockType = {
    name: "cherry_sapling",
    image: "https://minecraft.wiki/images/Cherry_Sapling_JE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.19.4",
    color: "pink"
}
export const CherrySign: BlockType = {
    name: "cherry_sign",
    image: "https://minecraft.wiki/images/Cherry_Sign_(0)_JE2_BE2.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherrySlab: BlockType = {
    name: "cherry_slab",
    image: "https://minecraft.wiki/images/Cherry_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryStairs: BlockType = {
    name: "cherry_stairs",
    image: "https://minecraft.wiki/images/Cherry_Stairs_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryTrapdoor: BlockType = {
    name: "cherry_trapdoor",
    image: "https://minecraft.wiki/images/Cherry_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19.4",
    color: "pink"
}
export const CherryWood: BlockType = {
    name: "cherry_wood",
    image: "https://minecraft.wiki/images/Cherry_Wood_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.19.4",
    color: "brown"
}
export const ChippedAnvil: BlockType = {
    name: "chipped_anvil",
    image: "https://minecraft.wiki/images/Chipped_Anvil_(N)_JE3.png",
    hardness: 5,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "1.4.2",
    color: "gray"
}
export const ChiseledBookshelf: BlockType = {
    name: "chiseled_bookshelf",
    image: "https://minecraft.wiki/images/Chiseled_Bookshelf_(S_0)_JE2.png",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Axe",
    version: "1.19.3",
    color: "brown"
}
export const ChiseledCopper: BlockType = {
    name: "chiseled_copper",
    image: "https://minecraft.wiki/images/Chiseled_Copper_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "orange"
}
export const ChiseledDeepslate: BlockType = {
    name: "chiseled_deepslate",
    image: "https://minecraft.wiki/images/Chiseled_Deepslate_JE2_BE1.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const ChiseledNetherBricks: BlockType = {
    name: "chiseled_nether_bricks",
    image: "https://minecraft.wiki/images/Chiseled_Nether_Bricks_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "maroon"
}
export const ChiseledPolishedBlackstone: BlockType = {
    name: "chiseled_polished_blackstone",
    image: "https://minecraft.wiki/images/Chiseled_Polished_Blackstone_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const ChiseledQuartzBlock: BlockType = {
    name: "chiseled_quartz_block",
    image: "https://minecraft.wiki/images/Chiseled_Quartz_Block_(UD)_JE2_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.5",
    color: "white"
}
export const ChiseledRedSandstone: BlockType = {
    name: "chiseled_red_sandstone",
    image: "https://minecraft.wiki/images/Chiseled_Red_Sandstone_JE4_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.8",
    color: "orange"
}
export const ChiseledResinBricks: BlockType = {
    name: "chiseled_resin_bricks",
    image: "https://minecraft.wiki/images/Chiseled_Resin_Bricks_JE2_BE3.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.21.4",
    color: "orange"
}
export const ChiseledSandstone: BlockType = {
    name: "chiseled_sandstone",
    image: "https://minecraft.wiki/images/Chiseled_Sandstone_JE5_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.2.1",
    color: "cream"
}
export const ChiseledStoneBricks: BlockType = {
    name: "chiseled_stone_bricks",
    image: "https://minecraft.wiki/images/Chiseled_Stone_Bricks_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.2.1",
    color: "gray"
}
export const ChiseledTuff: BlockType = {
    name: "chiseled_tuff",
    image: "https://minecraft.wiki/images/Chiseled_Tuff_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const ChiseledTuffBricks: BlockType = {
    name: "chiseled_tuff_bricks",
    image: "https://minecraft.wiki/images/Chiseled_Tuff_Bricks_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const ChorusFlower: BlockType = {
    name: "chorus_flower",
    image: "https://minecraft.wiki/images/Chorus_Flower_JE2_BE2.png",
    hardness: 0.4,
    blast_resistance: 0.4,
    tool: "Axe",
    version: "1.9",
    color: "purple"
}
export const ChorusPlant: BlockType = {
    name: "chorus_plant",
    image: "https://minecraft.wiki/images/Chorus_Plant_JE2_BE2.png",
    hardness: 0.4,
    blast_resistance: 0.4,
    tool: "Axe",
    version: "1.9",
    color: "purple"
}
export const Clay: BlockType = {
    name: "clay",
    image: "https://minecraft.wiki/images/Clay_JE2_BE2.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Shovel",
    version: "alpha",
    color: "gray"
}
export const CoalOre: BlockType = {
    name: "coal_ore",
    image: "https://minecraft.wiki/images/Coal_Ore_JE5_BE4.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "classic",
    color: "black"
}
export const CoarseDirt: BlockType = {
    name: "coarse_dirt",
    image: "https://minecraft.wiki/images/Coarse_Dirt.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.7.2",
    color: "brown"
}
export const CobbledDeepslate: BlockType = {
    name: "cobbled_deepslate",
    image: "https://minecraft.wiki/images/Cobbled_Deepslate.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const CobbledDeepslateSlab: BlockType = {
    name: "cobbled_deepslate_slab",
    image: "https://minecraft.wiki/images/Cobbled_Deepslate_Slab_JE3.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const CobbledDeepslateStairs: BlockType = {
    name: "cobbled_deepslate_stairs",
    image: "https://minecraft.wiki/images/Cobbled_Deepslate_Stairs_JE3.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const CobbledDeepslateWall: BlockType = {
    name: "cobbled_deepslate_wall",
    image: "https://minecraft.wiki/images/Cobbled_Deepslate_Wall_JE3.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const Cobblestone: BlockType = {
    name: "cobblestone",
    image: "https://minecraft.wiki/images/Cobblestone_JE5_BE3.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "pre-classic",
    color: "gray"
}
export const CobblestoneSlab: BlockType = {
    name: "cobblestone_slab",
    image: "https://minecraft.wiki/images/Cobblestone_Slab_JE4_BE3.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const CobblestoneStairs: BlockType = {
    name: "cobblestone_stairs",
    image: "https://minecraft.wiki/images/Cobblestone_Stairs_(N)_JE6_BE6.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "infdev",
    color: "gray"
}
export const CobblestoneWall: BlockType = {
    name: "cobblestone_wall",
    image: "https://minecraft.wiki/images/Cobblestone_Wall_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.4.2",
    color: "gray"
}
export const CocoaBeans: BlockType = {
    name: "cocoa_beans",
    image: "https://minecraft.wiki/images/Cocoa_Age_2_(S)_JE5.png",
    hardness: 0.2,
    blast_resistance: 3,
    tool: "Axe",
    version: "beta",
    color: "brown"
}
export const CommandBlock: BlockType = {
    name: "command_block",
    image: "https://minecraft.wiki/images/Impulse_Command_Block.gif",
    hardness: -1,
    blast_resistance: 3600000,
    tool: "None",
    version: "1.4.2",
    color: "orange"
}
export const Composter: BlockType = {
    name: "composter",
    image: "https://minecraft.wiki/images/Composter_JE1.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Axe",
    version: "1.14",
    color: "brown"
}
export const Conduit: BlockType = {
    name: "conduit",
    image: "https://minecraft.wiki/images/Conduit_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.13",
    color: "light_brown"
}
export const CopperBulb: BlockType = {
    name: "copper_bulb",
    image: "https://minecraft.wiki/images/Copper_Bulb_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "orange"
}
export const CopperDoor: BlockType = {
    name: "copper_door",
    image: "https://minecraft.wiki/images/Copper_Door_JE3_BE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "orange"
}
export const CopperGrate: BlockType = {
    name: "copper_grate",
    image: "https://minecraft.wiki/images/Copper_Grate_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "orange"
}
export const CopperOre: BlockType = {
    name: "copper_ore",
    image: "https://minecraft.wiki/images/Copper_Ore_JE2_BE2.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "orange"
}
export const CopperTrapdoor: BlockType = {
    name: "copper_trapdoor",
    image: "https://minecraft.wiki/images/Copper_Trapdoor_JE2_BE2.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "orange"
}
export const Cornflower: BlockType = {
    name: "cornflower",
    image: "https://minecraft.wiki/images/Cornflower_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.14",
    color: "light_blue"
}
export const CrackedDeepslateBricks: BlockType = {
    name: "cracked_deepslate_bricks",
    image: "https://minecraft.wiki/images/Cracked_Deepslate_Bricks_JE1_BE1.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const CrackedDeepslateTiles: BlockType = {
    name: "cracked_deepslate_tiles",
    image: "https://minecraft.wiki/images/Cracked_Deepslate_Tiles_JE1_BE1.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const CrackedNetherBricks: BlockType = {
    name: "cracked_nether_bricks",
    image: "https://minecraft.wiki/images/Cracked_Nether_Bricks_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "maroon"
}
export const CrackedPolishedBlackstoneBricks: BlockType = {
    name: "cracked_polished_blackstone_bricks",
    image: "https://minecraft.wiki/images/Cracked_Polished_Blackstone_Bricks_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const CrackedStoneBricks: BlockType = {
    name: "cracked_stone_bricks",
    image: "https://minecraft.wiki/images/Cracked_Stone_Bricks_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const Crafter: BlockType = {
    name: "crafter",
    image: "https://minecraft.wiki/images/Crafter_JE4_BE3.png",
    hardness: 1.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const CraftingTable: BlockType = {
    name: "crafting_table",
    image: "https://minecraft.wiki/images/Crafting_Table_JE4_BE3.png",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "indev",
    color: "light_brown"
}
export const CreakingHeart: BlockType = {
    name: "creaking_heart",
    image: "https://minecraft.wiki/images/Creaking_Heart_JE2_BE2.png",
    hardness: 5,
    blast_resistance: 5,
    tool: "Axe",
    version: "1.21.2",
    color: "brown"
}
export const CreeperHead: BlockType = {
    name: "creeper_head",
    image: "https://minecraft.wiki/images/Creeper_Head_(8).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Any",
    version: "1.4.2",
    color: "green"
}
export const CrimsonButton: BlockType = {
    name: "crimson_button",
    image: "https://minecraft.wiki/images/Crimson_Button_JE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.16",
    color: "maroon"
}
export const CrimsonDoor: BlockType = {
    name: "crimson_door",
    image: "https://minecraft.wiki/images/Crimson_Door_JE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CrimsonFence: BlockType = {
    name: "crimson_fence",
    image: "https://minecraft.wiki/images/Crimson_Fence_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CrimsonFenceGate: BlockType = {
    name: "crimson_fence_gate",
    image: "https://minecraft.wiki/images/Crimson_Fence_Gate_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CrimsonFungus: BlockType = {
    name: "crimson_fungus",
    image: "https://minecraft.wiki/images/Crimson_Fungus_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.16",
    color: "red"
}
export const CrimsonHangingSign: BlockType = {
    name: "crimson_hanging_sign",
    image: "https://minecraft.wiki/images/Crimson_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "maroon"
}
export const CrimsonHyphae: BlockType = {
    name: "crimson_hyphae",
    image: "https://minecraft.wiki/images/Crimson_Hyphae_(UD)_JE1.gif",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.16",
    color: "red"
}
export const CrimsonNylium: BlockType = {
    name: "crimson_nylium",
    image: "https://minecraft.wiki/images/Crimson_Nylium_JE1_BE1.png",
    hardness: 0.4,
    blast_resistance: 0.4,
    tool: "Pickaxe",
    version: "1.16",
    color: "red"
}
export const CrimsonPlanks: BlockType = {
    name: "crimson_planks",
    image: "https://minecraft.wiki/images/Crimson_Planks_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CrimsonPressurePlate: BlockType = {
    name: "crimson_pressure_plate",
    image: "https://minecraft.wiki/images/Crimson_Pressure_Plate_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CrimsonRoots: BlockType = {
    name: "crimson_roots",
    image: "https://minecraft.wiki/images/Crimson_Roots_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.16",
    color: "red"
}
export const CrimsonSign: BlockType = {
    name: "crimson_sign",
    image: "https://minecraft.wiki/images/Crimson_Sign_(0).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CrimsonSlab: BlockType = {
    name: "crimson_slab",
    image: "https://minecraft.wiki/images/Crimson_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CrimsonStairs: BlockType = {
    name: "crimson_stairs",
    image: "https://minecraft.wiki/images/Crimson_Stairs_(N)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CrimsonStem: BlockType = {
    name: "crimson_stem",
    image: "https://minecraft.wiki/images/Crimson_Stem_(UD)_JE1.gif",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.16",
    color: "red"
}
export const CrimsonTrapdoor: BlockType = {
    name: "crimson_trapdoor",
    image: "https://minecraft.wiki/images/Crimson_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "maroon"
}
export const CryingObsidian: BlockType = {
    name: "crying_obsidian",
    image: "https://minecraft.wiki/images/Crying_Obsidian_JE1_BE1.png",
    hardness: 50,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "beta",
    color: "purple"
}
export const CutCopper: BlockType = {
    name: "cut_copper",
    image: "https://minecraft.wiki/images/Cut_Copper_JE2_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "orange"
}
export const CutCopperSlab: BlockType = {
    name: "cut_copper_slab",
    image: "https://minecraft.wiki/images/Cut_Copper_Slab_JE2_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "orange"
}
export const CutCopperStairs: BlockType = {
    name: "cut_copper_stairs",
    image: "https://minecraft.wiki/images/Cut_Copper_Stairs_(N)_JE2_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "orange"
}
export const CutRedSandstone: BlockType = {
    name: "cut_red_sandstone",
    image: "https://minecraft.wiki/images/Cut_Red_Sandstone_JE4_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.8",
    color: "red"
}
export const CutRedSandstoneSlab: BlockType = {
    name: "cut_red_sandstone_slab",
    image: "https://minecraft.wiki/images/Cut_Red_Sandstone_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "red"
}
export const CutSandstone: BlockType = {
    name: "cut_sandstone",
    image: "https://minecraft.wiki/images/Cut_Sandstone_JE5_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.2.4",
    color: "cream"
}
export const CutSandstoneSlab: BlockType = {
    name: "cut_sandstone_slab",
    image: "https://minecraft.wiki/images/Cut_Sandstone_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "cream"
}
export const CyanBanner: BlockType = {
    name: "cyan_banner",
    image: "https://minecraft.wiki/images/Cyan_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "cyan"
}
export const CyanBed: BlockType = {
    name: "cyan_bed",
    image: "https://minecraft.wiki/images/Cyan_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "cyan"
}
export const CyanCandle: BlockType = {
    name: "cyan_candle",
    image: "https://minecraft.wiki/images/Cyan_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "cyan"
}
export const CyanCarpet: BlockType = {
    name: "cyan_carpet",
    image: "https://minecraft.wiki/images/Cyan_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "cyan"
}
export const CyanConcrete: BlockType = {
    name: "cyan_concrete",
    image: "https://minecraft.wiki/images/Cyan_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "cyan"
}
export const CyanConcretePowder: BlockType = {
    name: "cyan_concrete_powder",
    image: "https://minecraft.wiki/images/Cyan_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "cyan"
}
export const CyanGlazedTerracotta: BlockType = {
    name: "cyan_glazed_terracotta",
    image: "https://minecraft.wiki/images/Cyan_Glazed_Terracotta_JE2_BE2.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "cyan"
}
export const CyanShulkerBox: BlockType = {
    name: "cyan_shulker_box",
    image: "https://minecraft.wiki/images/Cyan_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "cyan"
}
export const CyanStainedGlass: BlockType = {
    name: "cyan_stained_glass",
    image: "https://minecraft.wiki/images/Cyan_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "cyan"
}
export const CyanStainedGlassPane: BlockType = {
    name: "cyan_stained_glass_pane",
    image: "https://minecraft.wiki/images/Cyan_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "cyan"
}
export const CyanStainedTerracotta: BlockType = {
    name: "cyan_stained_terracotta",
    image: "https://minecraft.wiki/images/Cyan_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "cyan"
}
export const CyanWool: BlockType = {
    name: "cyan_wool",
    image: "https://minecraft.wiki/images/Cyan_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "cyan"
}
export const DamagedAnvil: BlockType = {
    name: "damaged_anvil",
    image: "https://minecraft.wiki/images/Damaged_Anvil_(N)_JE3.png",
    hardness: 5,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "Java Edition",
    color: "gray"
}
export const Dandelion: BlockType = {
    name: "dandelion",
    image: "https://minecraft.wiki/images/Dandelion_JE8_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "classic",
    color: "yellow"
}
export const DarkOakButton: BlockType = {
    name: "dark_oak_button",
    image: "https://minecraft.wiki/images/Dark_Oak_Button_JE4.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.13",
    color: "dark_brown"
}
export const DarkOakDoor: BlockType = {
    name: "dark_oak_door",
    image: "https://minecraft.wiki/images/Dark_Oak_Door_JE4.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "dark_brown"
}
export const DarkOakFence: BlockType = {
    name: "dark_oak_fence",
    image: "https://minecraft.wiki/images/Dark_Oak_Fence_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "dark_brown"
}
export const DarkOakFenceGate: BlockType = {
    name: "dark_oak_fence_gate",
    image: "https://minecraft.wiki/images/Dark_Oak_Fence_Gate_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "dark_brown"
}
export const DarkOakHangingSign: BlockType = {
    name: "dark_oak_hanging_sign",
    image: "https://minecraft.wiki/images/Dark_Oak_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "dark_brown"
}
export const DarkOakLeaves: BlockType = {
    name: "dark_oak_leaves",
    image: "https://minecraft.wiki/images/Dark_Oak_Leaves.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "1.7.2",
    color: "green"
}
export const DarkOakLog: BlockType = {
    name: "dark_oak_log",
    image: "https://minecraft.wiki/images/Dark_Oak_Log_(UD)_JE6_BE4.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.7.2",
    color: "dark_brown"
}
export const DarkOakPlanks: BlockType = {
    name: "dark_oak_planks",
    image: "https://minecraft.wiki/images/Dark_Oak_Planks_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.7.2",
    color: "dark_brown"
}
export const DarkOakPressurePlate: BlockType = {
    name: "dark_oak_pressure_plate",
    image: "https://minecraft.wiki/images/Dark_Oak_Pressure_Plate_JE3_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.13",
    color: "dark_brown"
}
export const DarkOakSapling: BlockType = {
    name: "dark_oak_sapling",
    image: "https://minecraft.wiki/images/Dark_Oak_Sapling_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "green"
}
export const DarkOakSign: BlockType = {
    name: "dark_oak_sign",
    image: "https://minecraft.wiki/images/Dark_Oak_Sign_(0).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.14",
    color: "dark_brown"
}
export const DarkOakSlab: BlockType = {
    name: "dark_oak_slab",
    image: "https://minecraft.wiki/images/Dark_Oak_Slab_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.7.2",
    color: "dark_brown"
}
export const DarkOakStairs: BlockType = {
    name: "dark_oak_stairs",
    image: "https://minecraft.wiki/images/Dark_Oak_Stairs_(N)_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.7.2",
    color: "dark_brown"
}
export const DarkOakTrapdoor: BlockType = {
    name: "dark_oak_trapdoor",
    image: "https://minecraft.wiki/images/Dark_Oak_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.13",
    color: "dark_brown"
}
export const DarkOakWood: BlockType = {
    name: "dark_oak_wood",
    image: "https://minecraft.wiki/images/Dark_Oak_Wood_(UD)_JE5_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "dark_brown"
}
export const DarkPrismarine: BlockType = {
    name: "dark_prismarine",
    image: "https://minecraft.wiki/images/Dark_Prismarine_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "dark_turquoise"
}
export const DarkPrismarineSlab: BlockType = {
    name: "dark_prismarine_slab",
    image: "https://minecraft.wiki/images/Dark_Prismarine_Slab_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "dark_turquoise"
}
export const DarkPrismarineStairs: BlockType = {
    name: "dark_prismarine_stairs",
    image: "https://minecraft.wiki/images/Dark_Prismarine_Stairs_(N)_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "dark_turquoise"
}
export const DaylightDetector: BlockType = {
    name: "daylight_detector",
    image: "https://minecraft.wiki/images/Daylight_Detector_JE1_BE1.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Axe",
    version: "1.5",
    color: "dark_brown"
}
export const DeadBrainCoral: BlockType = {
    name: "dead_brain_coral",
    image: "https://minecraft.wiki/images/Dead_Brain_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13.1",
    color: "gray"
}
export const DeadBrainCoralBlock: BlockType = {
    name: "dead_brain_coral_block",
    image: "https://minecraft.wiki/images/Dead_Brain_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "gray"
}
export const DeadBrainCoralFan: BlockType = {
    name: "dead_brain_coral_fan",
    image: "https://minecraft.wiki/images/Dead_Brain_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "gray"
}
export const DeadBubbleCoral: BlockType = {
    name: "dead_bubble_coral",
    image: "https://minecraft.wiki/images/Dead_Bubble_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13.1",
    color: "gray"
}
export const DeadBubbleCoralBlock: BlockType = {
    name: "dead_bubble_coral_block",
    image: "https://minecraft.wiki/images/Dead_Bubble_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "gray"
}
export const DeadBubbleCoralFan: BlockType = {
    name: "dead_bubble_coral_fan",
    image: "https://minecraft.wiki/images/Dead_Bubble_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "gray"
}
export const DeadBush: BlockType = {
    name: "dead_bush",
    image: "https://minecraft.wiki/images/Dead_Bush_JE2_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "beta",
    color: "brown"
}
export const DeadFireCoral: BlockType = {
    name: "dead_fire_coral",
    image: "https://minecraft.wiki/images/Dead_Fire_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13.1",
    color: "gray"
}
export const DeadFireCoralBlock: BlockType = {
    name: "dead_fire_coral_block",
    image: "https://minecraft.wiki/images/Dead_Fire_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "gray"
}
export const DeadFireCoralFan: BlockType = {
    name: "dead_fire_coral_fan",
    image: "https://minecraft.wiki/images/Dead_Fire_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "gray"
}
export const DeadHornCoral: BlockType = {
    name: "dead_horn_coral",
    image: "https://minecraft.wiki/images/Dead_Horn_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13.1",
    color: "gray"
}
export const DeadHornCoralBlock: BlockType = {
    name: "dead_horn_coral_block",
    image: "https://minecraft.wiki/images/Dead_Horn_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "gray"
}
export const DeadHornCoralFan: BlockType = {
    name: "dead_horn_coral_fan",
    image: "https://minecraft.wiki/images/Dead_Horn_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "gray"
}
export const DeadTubeCoral: BlockType = {
    name: "dead_tube_coral",
    image: "https://minecraft.wiki/images/Dead_Tube_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13.1",
    color: "gray"
}
export const DeadTubeCoralBlock: BlockType = {
    name: "dead_tube_coral_block",
    image: "https://minecraft.wiki/images/Dead_Tube_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "gray"
}
export const DeadTubeCoralFan: BlockType = {
    name: "dead_tube_coral_fan",
    image: "https://minecraft.wiki/images/Dead_Tube_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "gray"
}
export const DecoratedPot: BlockType = {
    name: "decorated_pot",
    image: "https://minecraft.wiki/images/Decorated_Pot_(N)_JE2_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.19.4",
    color: "brown"
}
export const Deepslate: BlockType = {
    name: "deepslate",
    image: "https://minecraft.wiki/images/Deepslate.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const DeepslateBricks: BlockType = {
    name: "deepslate_bricks",
    image: "https://minecraft.wiki/images/Deepslate_Bricks_JE2_BE1.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const DeepslateBrickSlab: BlockType = {
    name: "deepslate_brick_slab",
    image: "https://minecraft.wiki/images/Deepslate_Brick_Slab_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const DeepslateBrickStairs: BlockType = {
    name: "deepslate_brick_stairs",
    image: "https://minecraft.wiki/images/Deepslate_Brick_Stairs_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const DeepslateBrickWall: BlockType = {
    name: "deepslate_brick_wall",
    image: "https://minecraft.wiki/images/Deepslate_Brick_Wall_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const DeepslateCoalOre: BlockType = {
    name: "deepslate_coal_ore",
    image: "https://minecraft.wiki/images/Deepslate_Coal_Ore_JE1_BE2.png",
    hardness: 4.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const DeepslateCopperOre: BlockType = {
    name: "deepslate_copper_ore",
    image: "https://minecraft.wiki/images/Deepslate_Copper_Ore_JE2_BE2.png",
    hardness: 4.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "orange"
}
export const DeepslateDiamondOre: BlockType = {
    name: "deepslate_diamond_ore",
    image: "https://minecraft.wiki/images/Deepslate_Diamond_Ore_JE2_BE1.png",
    hardness: 4.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "light_blue"
}
export const DeepslateEmeraldOre: BlockType = {
    name: "deepslate_emerald_ore",
    image: "https://minecraft.wiki/images/Deepslate_Emerald_Ore_JE1_BE1.png",
    hardness: 4.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "green"
}
export const DeepslateGoldOre: BlockType = {
    name: "deepslate_gold_ore",
    image: "https://minecraft.wiki/images/Deepslate_Gold_Ore_JE2_BE1.png",
    hardness: 4.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "yellow"
}
export const DeepslateIronOre: BlockType = {
    name: "deepslate_iron_ore",
    image: "https://minecraft.wiki/images/Deepslate_Iron_Ore_JE2_BE1.png",
    hardness: 4.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "brown"
}
export const DeepslateLapisLazuliOre: BlockType = {
    name: "deepslate_lapis_lazuli_ore",
    image: "https://minecraft.wiki/images/Deepslate_Lapis_Lazuli_Ore_JE3_BE2.png",
    hardness: 4.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "blue"
}
export const DeepslateRedstoneOre: BlockType = {
    name: "deepslate_redstone_ore",
    image: "https://minecraft.wiki/images/Deepslate_Redstone_Ore_JE2_BE1.png",
    hardness: 4.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "red"
}
export const DeepslateTiles: BlockType = {
    name: "deepslate_tiles",
    image: "https://minecraft.wiki/images/Deepslate_Tiles_JE2_BE1.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const DeepslateTileSlab: BlockType = {
    name: "deepslate_tile_slab",
    image: "https://minecraft.wiki/images/Deepslate_Tile_Slab_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const DeepslateTileStairs: BlockType = {
    name: "deepslate_tile_stairs",
    image: "https://minecraft.wiki/images/Deepslate_Tile_Stairs_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const DeepslateTileWall: BlockType = {
    name: "deepslate_tile_wall",
    image: "https://minecraft.wiki/images/Deepslate_Tile_Wall_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "black"
}
export const DetectorRail: BlockType = {
    name: "detector_rail",
    image: "https://minecraft.wiki/images/Detector_Rail_(NS)_JE2_BE2.png",
    hardness: 0.7,
    blast_resistance: 0.7,
    tool: "Pickaxe",
    version: "1.5",
    color: "brown"
}
export const DiamondOre: BlockType = {
    name: "diamond_ore",
    image: "https://minecraft.wiki/images/Diamond_Ore_JE5_BE5.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "indev",
    color: "light_blue"
}
export const DioriteSlab: BlockType = {
    name: "diorite_slab",
    image: "https://minecraft.wiki/images/Diorite_Slab_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "white"
}
export const DioriteStairs: BlockType = {
    name: "diorite_stairs",
    image: "https://minecraft.wiki/images/Diorite_Stairs_(N)_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "white"
}
export const DioriteWall: BlockType = {
    name: "diorite_wall",
    image: "https://minecraft.wiki/images/Diorite_Wall_JE3_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "white"
}
export const DirtPath: BlockType = {
    name: "dirt_path",
    image: "https://minecraft.wiki/images/Dirt_Path_JE4_BE3.png",
    hardness: 0.65,
    blast_resistance: 0.65,
    tool: "Shovel",
    version: "1.9",
    color: "brown"
}
export const Dispenser: BlockType = {
    name: "dispenser",
    image: "https://minecraft.wiki/images/Dispenser_(S)_JE4.png",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const DragonEgg: BlockType = {
    name: "dragon_egg",
    image: "https://minecraft.wiki/images/Dragon_Egg_JE5.png",
    hardness: 3,
    blast_resistance: 9,
    tool: "None",
    version: "1.0.0",
    color: "black"
}
export const DragonHead: BlockType = {
    name: "dragon_head",
    image: "https://minecraft.wiki/images/Dragon_Head_(8).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Any",
    version: "1.9",
    color: "black"
}
export const DriedKelpBlock: BlockType = {
    name: "dried_kelp_block",
    image: "https://minecraft.wiki/images/Dried_Kelp_Block_JE1_BE2.png",
    hardness: 0.5,
    blast_resistance: 2.5,
    tool: "Hoe",
    version: "1.13",
    color: "black"
}
export const DripstoneBlock: BlockType = {
    name: "dripstone_block",
    image: "https://minecraft.wiki/images/Dripstone_Block_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 1,
    tool: "Pickaxe",
    version: "1.17",
    color: "brown"
}
export const Dropper: BlockType = {
    name: "dropper",
    image: "https://minecraft.wiki/images/Dropper_(S)_JE3.png",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "1.5",
    color: "gray"
}
export const EmeraldOre: BlockType = {
    name: "emerald_ore",
    image: "https://minecraft.wiki/images/Emerald_Ore_JE4_BE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.3.1",
    color: "green"
}
export const EnchantingTable: BlockType = {
    name: "enchanting_table",
    image: "https://minecraft.wiki/images/Enchanting_Table.gif",
    hardness: 5,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "1.0.0",
    color: "black"
}
export const EndGateway: BlockType = {
    name: "end_gateway",
    image: "https://minecraft.wiki/images/End_Gateway.gif",
    hardness: -1,
    blast_resistance: 3600000,
    tool: "None",
    version: "1.9",
    color: "black"
}
export const EndPortal: BlockType = {
    name: "end_portal",
    image: "https://minecraft.wiki/images/End_Portal_(block).gif",
    hardness: -1,
    blast_resistance: 3600000,
    tool: "None",
    version: "1.0.0",
    color: "black"
}
export const EndPortalFrame: BlockType = {
    name: "end_portal_frame",
    image: "https://minecraft.wiki/images/End_Portal_Frame_(S)_JE6_BE3.png",
    hardness: -1,
    blast_resistance: 360000,
    tool: "None",
    version: "1.0.0",
    color: "cream"
}
export const EndRod: BlockType = {
    name: "end_rod",
    image: "https://minecraft.wiki/images/End_Rod_(U)_JE2_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.9",
    color: "white"
}
export const EndStone: BlockType = {
    name: "end_stone",
    image: "https://minecraft.wiki/images/End_Stone_JE3_BE2.png",
    hardness: 3,
    blast_resistance: 9,
    tool: "Pickaxe",
    version: "1.0.0",
    color: "cream"
}
export const EndStoneBrickSlab: BlockType = {
    name: "end_stone_brick_slab",
    image: "https://minecraft.wiki/images/End_Stone_Brick_Slab_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 9,
    tool: "Pickaxe",
    version: "1.14",
    color: "cream"
}
export const EndStoneBrickStairs: BlockType = {
    name: "end_stone_brick_stairs",
    image: "https://minecraft.wiki/images/End_Stone_Brick_Stairs_(N)_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 9,
    tool: "Pickaxe",
    version: "1.14",
    color: "cream"
}
export const EndStoneBrickWall: BlockType = {
    name: "end_stone_brick_wall",
    image: "https://minecraft.wiki/images/End_Stone_Brick_Wall_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 9,
    tool: "Pickaxe",
    version: "1.14",
    color: "cream"
}
export const EndStoneBricks: BlockType = {
    name: "end_stone_bricks",
    image: "https://minecraft.wiki/images/End_Stone_Bricks_JE2_BE2.png",
    hardness: 3,
    blast_resistance: 9,
    tool: "Pickaxe",
    version: "1.9",
    color: "cream"
}
export const EnderChest: BlockType = {
    name: "ender_chest",
    image: "https://minecraft.wiki/images/Ender_Chest_JE2_BE2.gif",
    hardness: 22.5,
    blast_resistance: 600,
    tool: "Pickaxe",
    version: "1.3.1",
    color: "black"
}
export const ExposedChiseledCopper: BlockType = {
    name: "exposed_chiseled_copper",
    image: "https://minecraft.wiki/images/Exposed_Chiseled_Copper_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "brown"
}
export const ExposedCopper: BlockType = {
    name: "exposed_copper",
    image: "https://minecraft.wiki/images/Exposed_Copper_Block_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "brown"
}
export const ExposedCopperBulb: BlockType = {
    name: "exposed_copper_bulb",
    image: "https://minecraft.wiki/images/Exposed_Copper_Bulb_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "brown"
}
export const ExposedCopperDoor: BlockType = {
    name: "exposed_copper_door",
    image: "https://minecraft.wiki/images/Exposed_Copper_Door_JE3_BE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "brown"
}
export const ExposedCopperGrate: BlockType = {
    name: "exposed_copper_grate",
    image: "https://minecraft.wiki/images/Exposed_Copper_Grate_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "brown"
}
export const ExposedCopperTrapdoor: BlockType = {
    name: "exposed_copper_trapdoor",
    image: "https://minecraft.wiki/images/Exposed_Copper_Trapdoor_JE2_BE2.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "brown"
}
export const ExposedCutCopper: BlockType = {
    name: "exposed_cut_copper",
    image: "https://minecraft.wiki/images/Exposed_Cut_Copper_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "brown"
}
export const ExposedCutCopperSlab: BlockType = {
    name: "exposed_cut_copper_slab",
    image: "https://minecraft.wiki/images/Exposed_Cut_Copper_Slab_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "brown"
}
export const ExposedCutCopperStairs: BlockType = {
    name: "exposed_cut_copper_stairs",
    image: "https://minecraft.wiki/images/Exposed_Cut_Copper_Stairs_(N)_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "brown"
}
export const Farmland: BlockType = {
    name: "farmland",
    image: "https://minecraft.wiki/images/Farmland_JE4_BE6.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Shovel",
    version: "indev",
    color: "brown"
}
export const Fern: BlockType = {
    name: "fern",
    image: "https://minecraft.wiki/images/Fern.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "beta",
    color: "green"
}
export const Fire: BlockType = {
    name: "fire",
    image: "https://minecraft.wiki/images/Fire.gif",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "indev",
    color: "orange"
}
export const FireCoral: BlockType = {
    name: "fire_coral",
    image: "https://minecraft.wiki/images/Fire_Coral_JE2_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "red"
}
export const FireCoralBlock: BlockType = {
    name: "fire_coral_block",
    image: "https://minecraft.wiki/images/Fire_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "red"
}
export const FireCoralFan: BlockType = {
    name: "fire_coral_fan",
    image: "https://minecraft.wiki/images/Fire_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "red"
}
export const FletchingTable: BlockType = {
    name: "fletching_table",
    image: "https://minecraft.wiki/images/Fletching_Table_JE2_BE1.png",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "1.14",
    color: "cream"
}
export const FlowerPot: BlockType = {
    name: "flower_pot",
    image: "https://minecraft.wiki/images/Flower_Pot_JE3.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.4.2",
    color: "brown"
}
export const FloweringAzalea: BlockType = {
    name: "flowering_azalea",
    image: "https://minecraft.wiki/images/Flowering_Azalea_JE2_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.17",
    color: "green"
}
export const FloweringAzaleaLeaves: BlockType = {
    name: "flowering_azalea_leaves",
    image: "https://minecraft.wiki/images/Flowering_Azalea_Leaves.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "1.17",
    color: "green"
}
export const Frogspawn: BlockType = {
    name: "frogspawn",
    image: "https://minecraft.wiki/images/Frogspawn_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.19",
    color: "gray"
}
export const FrostedIce: BlockType = {
    name: "frosted_ice",
    image: "https://minecraft.wiki/images/Frosted_Ice_JE2_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "None",
    version: "1.9",
    color: "light_blue"
}
export const Furnace: BlockType = {
    name: "furnace",
    image: "https://minecraft.wiki/images/Furnace_(S)_JE4.png",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "indev",
    color: "gray"
}
export const GildedBlackstone: BlockType = {
    name: "gilded_blackstone",
    image: "https://minecraft.wiki/images/Gilded_Blackstone_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const GlassPane: BlockType = {
    name: "glass_pane",
    image: "https://minecraft.wiki/images/Glass_Pane_JE4_BE4.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "beta",
    color: "none"
}
export const GlowLichen: BlockType = {
    name: "glow_lichen",
    image: "https://minecraft.wiki/images/Glow_Lichen_(N)_JE1.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "1.17",
    color: "green"
}
export const Glowstone: BlockType = {
    name: "glowstone",
    image: "https://minecraft.wiki/images/Glowstone_JE4_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "alpha",
    color: "yellow"
}
export const GoldOre: BlockType = {
    name: "gold_ore",
    image: "https://minecraft.wiki/images/Gold_Ore_JE7_BE4.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "classic",
    color: "yellow"
}
export const Granite: BlockType = {
    name: "granite",
    image: "https://minecraft.wiki/images/Granite.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "brown"
}
export const GraniteSlab: BlockType = {
    name: "granite_slab",
    image: "https://minecraft.wiki/images/Granite_Slab_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "brown"
}
export const GraniteStairs: BlockType = {
    name: "granite_stairs",
    image: "https://minecraft.wiki/images/Granite_Stairs_(N)_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "brown"
}
export const GraniteWall: BlockType = {
    name: "granite_wall",
    image: "https://minecraft.wiki/images/Granite_Wall_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "brown"
}
export const GrassBlock: BlockType = {
    name: "grass_block",
    image: "https://minecraft.wiki/images/Grass_Block_JE7_BE6.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Shovel",
    version: "pre-classic",
    color: "brown"
}
export const GrayBanner: BlockType = {
    name: "gray_banner",
    image: "https://minecraft.wiki/images/Gray_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "gray"
}
export const GrayBed: BlockType = {
    name: "gray_bed",
    image: "https://minecraft.wiki/images/Gray_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "gray"
}
export const GrayCandle: BlockType = {
    name: "gray_candle",
    image: "https://minecraft.wiki/images/Gray_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "gray"
}
export const GrayCarpet: BlockType = {
    name: "gray_carpet",
    image: "https://minecraft.wiki/images/Gray_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "gray"
}
export const GrayConcrete: BlockType = {
    name: "gray_concrete",
    image: "https://minecraft.wiki/images/Gray_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "gray"
}
export const GrayConcretePowder: BlockType = {
    name: "gray_concrete_powder",
    image: "https://minecraft.wiki/images/Gray_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "gray"
}
export const GrayGlazedTerracotta: BlockType = {
    name: "gray_glazed_terracotta",
    image: "https://minecraft.wiki/images/Gray_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "gray"
}
export const GrayShulkerBox: BlockType = {
    name: "gray_shulker_box",
    image: "https://minecraft.wiki/images/Gray_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "gray"
}
export const GrayStainedGlass: BlockType = {
    name: "gray_stained_glass",
    image: "https://minecraft.wiki/images/Gray_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "gray"
}
export const GrayStainedGlassPane: BlockType = {
    name: "gray_stained_glass_pane",
    image: "https://minecraft.wiki/images/Gray_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "gray"
}
export const GrayStainedTerracotta: BlockType = {
    name: "gray_stained_terracotta",
    image: "https://minecraft.wiki/images/Gray_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "gray"
}
export const GrayWool: BlockType = {
    name: "gray_wool",
    image: "https://minecraft.wiki/images/Gray_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "gray"
}

export const GreenBanner: BlockType = {
    name: "green_banner",
    image: "https://minecraft.wiki/images/Green_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "green"
}
export const GreenBed: BlockType = {
    name: "green_bed",
    image: "https://minecraft.wiki/images/Green_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "green"
}
export const GreenCandle: BlockType = {
    name: "green_candle",
    image: "https://minecraft.wiki/images/Green_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "green"
}
export const GreenCarpet: BlockType = {
    name: "green_carpet",
    image: "https://minecraft.wiki/images/Green_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "green"
}
export const GreenConcrete: BlockType = {
    name: "green_concrete",
    image: "https://minecraft.wiki/images/Green_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "green"
}
export const GreenConcretePowder: BlockType = {
    name: "green_concrete_powder",
    image: "https://minecraft.wiki/images/Green_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "green"
}
export const GreenGlazedTerracotta: BlockType = {
    name: "green_glazed_terracotta",
    image: "https://minecraft.wiki/images/Green_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "green"
}
export const GreenShulkerBox: BlockType = {
    name: "green_shulker_box",
    image: "https://minecraft.wiki/images/Green_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "green"
}
export const GreenStainedGlass: BlockType = {
    name: "green_stained_glass",
    image: "https://minecraft.wiki/images/Green_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "green"
}
export const GreenStainedGlassPane: BlockType = {
    name: "green_stained_glass_pane",
    image: "https://minecraft.wiki/images/Green_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "green"
}
export const GreenStainedTerracotta: BlockType = {
    name: "green_stained_terracotta",
    image: "https://minecraft.wiki/images/Green_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "green"
}
export const GreenWool: BlockType = {
    name: "green_wool",
    image: "https://minecraft.wiki/images/Green_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "green"
}
export const Grindstone: BlockType = {
    name: "grindstone",
    image: "https://minecraft.wiki/images/Grindstone_(floor)_(N).png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const HangingRoots: BlockType = {
    name: "hanging_roots",
    image: "https://minecraft.wiki/images/Hanging_Roots_JE2_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "1.17",
    color: "light_brown"
}
export const HayBale: BlockType = {
    name: "hay_bale",
    image: "https://minecraft.wiki/images/Hay_Bale_(UD)_JE2_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Hoe",
    version: "1.6.1",
    color: "yellow"
}
export const HeavyCore: BlockType = {
    name: "heavy_core",
    image: "https://minecraft.wiki/images/Heavy_Core_JE1_BE1.png",
    hardness: 10,
    blast_resistance: 30,
    tool: "Pickaxe",
    version: "1.20.5",
    color: "gray"
}
export const HeavyWeightedPressurePlate: BlockType = {
    name: "heavy_weighted_pressure_plate",
    image: "https://minecraft.wiki/images/Heavy_Weighted_Pressure_Plate_JE2_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "1.5",
    color: "white"
}
export const HoneyBlock: BlockType = {
    name: "honey_block",
    image: "https://minecraft.wiki/images/Honey_Block_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.15",
    color: "yellow"
}
export const HoneycombBlock: BlockType = {
    name: "honeycomb_block",
    image: "https://minecraft.wiki/images/Honeycomb_Block_JE1_BE1.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Any",
    version: "1.15",
    color: "yellow"
}
export const Hopper: BlockType = {
    name: "hopper",
    image: "https://minecraft.wiki/images/Hopper_(D)_JE8.png",
    hardness: 3,
    blast_resistance: 4.8,
    tool: "Pickaxe",
    version: "1.5",
    color: "dark_gray"
}
export const HornCoral: BlockType = {
    name: "horn_coral",
    image: "https://minecraft.wiki/images/Horn_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "yellow"
}
export const HornCoralBlock: BlockType = {
    name: "horn_coral_block",
    image: "https://minecraft.wiki/images/Horn_Coral_Block_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "yellow"
}
export const HornCoralFan: BlockType = {
    name: "horn_coral_fan",
    image: "https://minecraft.wiki/images/Horn_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "yellow"
}
export const Ice: BlockType = {
    name: "ice",
    image: "https://minecraft.wiki/images/Ice_JE2_BE3.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "alpha",
    color: "light_blue"
}
export const InfestedStone: BlockType = {
    name: "infested_stone",
    image: "https://minecraft.wiki/images/Stone_JE8.png",
    hardness: 0.75,
    blast_resistance: 0.75,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const InfestedCobblestone: BlockType = {
    name: "infested_cobblestone",
    image: "https://minecraft.wiki/images/Cobblestone_JE5_BE3.png",
    hardness: 1,
    blast_resistance: 0.75,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const InfestedDeepslate: BlockType = {
    name: "infested_deepslate",
    image: "https://minecraft.wiki/images/Deepslate.png",
    hardness: 1.5,
    blast_resistance: 0.75,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const IronBars: BlockType = {
    name: "iron_bars",
    image: "https://minecraft.wiki/images/Iron_Bars_(EW)_JE3_BE2.png",
    hardness: 5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const IronDoor: BlockType = {
    name: "iron_door",
    image: "https://minecraft.wiki/images/Iron_Door_JE5.png",
    hardness: 5,
    blast_resistance: 5,
    tool: "Pickaxe",
    version: "alpha",
    color: "light_gray"
}
export const IronOre: BlockType = {
    name: "iron_ore",
    image: "https://minecraft.wiki/images/Iron_Ore_JE6_BE4.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "classic",
    color: "light_brown"
}
export const IronTrapdoor: BlockType = {
    name: "iron_trapdoor",
    image: "https://minecraft.wiki/images/Iron_Trapdoor_JE3_BE2.png",
    hardness: 5,
    blast_resistance: 5,
    tool: "Pickaxe",
    version: "1.8",
    color: "light_gray"
}
export const JackoLantern: BlockType = {
    name: "jack_o_lantern",
    image: "https://minecraft.wiki/images/Jack_o%27Lantern_(S)_JE4.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "alpha",
    color: "orange"
}
export const JigsawBlock: BlockType = {
    name: "jigsaw_block",
    image: "https://minecraft.wiki/images/Jigsaw_Block_(S)_JE3_BE2.png",
    hardness: -1,
    blast_resistance: 3600000,
    tool: "None",
    version: "1.14",
    color: "black"
}
export const Jukebox: BlockType = {
    name: "jukebox",
    image: "https://minecraft.wiki/images/Jukebox_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Axe",
    version: "alpha",
    color: "brown"
}
export const JungleButton: BlockType = {
    name: "jungle_button",
    image: "https://minecraft.wiki/images/Jungle_Button_JE4.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.4.2",
    color: "jungle"
}
export const JungleDoor: BlockType = {
    name: "jungle_door",
    image: "https://minecraft.wiki/images/Jungle_Door_JE5.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "jungle"
}
export const JungleFence: BlockType = {
    name: "jungle_fence",
    image: "https://minecraft.wiki/images/Jungle_Fence_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "jungle"
}
export const JungleFenceGate: BlockType = {
    name: "jungle_fence_gate",
    image: "https://minecraft.wiki/images/Jungle_Fence_Gate_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "jungle"
}
export const JungleHangingSign: BlockType = {
    name: "jungle_hanging_sign",
    image: "https://minecraft.wiki/images/Jungle_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "jungle"
}
export const JungleLeaves: BlockType = {
    name: "jungle_leaves",
    image: "https://minecraft.wiki/images/Jungle_Leaves.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "1.2.1",
    color: "green"
}
export const JungleLog: BlockType = {
    name: "jungle_log",
    image: "https://minecraft.wiki/images/Jungle_Log_(UD)_JE6_BE3.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.2.1",
    color: "brown"
}
export const JunglePlanks: BlockType = {
    name: "jungle_planks",
    image: "https://minecraft.wiki/images/Jungle_Planks_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.2.1",
    color: "jungle"
}
export const JunglePressurePlate: BlockType = {
    name: "jungle_pressure_plate",
    image: "https://minecraft.wiki/images/Jungle_Pressure_Plate_JE3_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.13",
    color: "jungle"
}
export const JungleSapling: BlockType = {
    name: "jungle_sapling",
    image: "https://minecraft.wiki/images/Jungle_Sapling_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.2.1",
    color: "green"
}
export const JungleSign: BlockType = {
    name: "jungle_sign",
    image: "https://minecraft.wiki/images/Jungle_Sign_(0).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.14",
    color: "jungle"
}
export const JungleSlab: BlockType = {
    name: "jungle_slab",
    image: "https://minecraft.wiki/images/Jungle_Slab_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.3.1",
    color: "jungle"
}
export const JungleStairs: BlockType = {
    name: "jungle_stairs",
    image: "https://minecraft.wiki/images/Jungle_Stairs_(N)_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.3.1",
    color: "jungle"
}
export const JungleTrapdoor: BlockType = {
    name: "jungle_trapdoor",
    image: "https://minecraft.wiki/images/Jungle_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.13",
    color: "jungle"
}
export const JungleWood: BlockType = {
    name: "jungle_wood",
    image: "https://minecraft.wiki/images/Jungle_Wood_(UD)_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "brown"
}
export const Kelp: BlockType = {
    name: "kelp",
    image: "https://minecraft.wiki/images/Kelp_JE3_BE2.gif",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "green"
}
export const Ladder: BlockType = {
    name: "ladder",
    image: "https://minecraft.wiki/images/Ladder_(S)_JE4.png",
    hardness: 0.4,
    blast_resistance: 0.4,
    tool: "Axe",
    version: "infdev",
    color: "brown"
}
export const Lantern: BlockType = {
    name: "lantern",
    image: "https://minecraft.wiki/images/Lantern_JE1_BE1.gif",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "1.14",
    color: "yellow"
}
export const LapisLazuliOre: BlockType = {
    name: "lapis_lazuli_ore",
    image: "https://minecraft.wiki/images/Lapis_Lazuli_Ore_JE4_BE4.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "beta",
    color: "blue"
}
export const LargeAmethystBud: BlockType = {
    name: "large_amethyst_bud",
    image: "https://minecraft.wiki/images/Large_Amethyst_Bud_(U)_JE1.png",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Pickaxe",
    version: "1.17",
    color: "purple"
}
export const LargeFern: BlockType = {
    name: "large_fern",
    image: "https://minecraft.wiki/images/Large_Fern.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "1.7.2",
    color: "dark_green"
}
export const Lava: BlockType = {
    name: "lava",
    image: "https://minecraft.wiki/images/Lava_JE14.gif",
    hardness: 100,
    blast_resistance: 100,
    tool: "Bucket",
    version: "classic",
    color: "orange"
}
export const Lectern: BlockType = {
    name: "lectern",
    image: "https://minecraft.wiki/images/Lectern_(S).png",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "1.14",
    color: "light_brown"
}
export const Lever: BlockType = {
    name: "lever",
    image: "https://minecraft.wiki/images/Wall_Lever_(S)_JE5-L3.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "alpha",
    color: "gray"
}
export const Light: BlockType = {
    name: "light",
    image: "https://minecraft.wiki/images/Light_15_JE3.png",
    hardness: -1,
    blast_resistance: 3600000.8,
    tool: "None",
    version: "1.17",
    color: "none"
}
export const LightBlueBanner: BlockType = {
    name: "light_blue_banner",
    image: "https://minecraft.wiki/images/Light_Blue_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "light_blue"
}
export const LightBlueBed: BlockType = {
    name: "light_blue_bed",
    image: "https://minecraft.wiki/images/Light_Blue_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "light_blue"
}
export const LightBlueCandle: BlockType = {
    name: "light_blue_candle",
    image: "https://minecraft.wiki/images/Light_Blue_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "light_blue"
}
export const LightBlueCarpet: BlockType = {
    name: "light_blue_carpet",
    image: "https://minecraft.wiki/images/Light_Blue_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "light_blue"
}
export const LightBlueConcrete: BlockType = {
    name: "light_blue_concrete",
    image: "https://minecraft.wiki/images/Light_Blue_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "light_blue"
}
export const LightBlueConcretePowder: BlockType = {
    name: "light_blue_concrete_powder",
    image: "https://minecraft.wiki/images/Light_Blue_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "light_blue"
}
export const LightBlueGlazedTerracotta: BlockType = {
    name: "light_blue_glazed_terracotta",
    image: "https://minecraft.wiki/images/Light_Blue_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "light_blue"
}
export const LightBlueShulkerBox: BlockType = {
    name: "light_blue_shulker_box",
    image: "https://minecraft.wiki/images/Light_Blue_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "light_blue"
}
export const LightBlueStainedGlass: BlockType = {
    name: "light_blue_stained_glass",
    image: "https://minecraft.wiki/images/Light_Blue_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "light_blue"
}
export const LightBlueStainedGlassPane: BlockType = {
    name: "light_blue_stained_glass_pane",
    image: "https://minecraft.wiki/images/Light_Blue_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "light_blue"
}
export const LightBlueStainedTerracotta: BlockType = {
    name: "light_blue_stained_terracotta",
    image: "https://minecraft.wiki/images/Light_Blue_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "light_blue"
}
export const LightBlueWool: BlockType = {
    name: "light_blue_wool",
    image: "https://minecraft.wiki/images/Light_Blue_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "light_blue"
}
export const LightGrayBanner: BlockType = {
    name: "light_gray_banner",
    image: "https://minecraft.wiki/images/Light_Gray_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "light_gray"
}
export const LightGrayBed: BlockType = {
    name: "light_gray_bed",
    image: "https://minecraft.wiki/images/Light_Gray_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "light_gray"
}
export const LightGrayCandle: BlockType = {
    name: "light_gray_candle",
    image: "https://minecraft.wiki/images/Light_Gray_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "light_gray"
}
export const LightGrayCarpet: BlockType = {
    name: "light_gray_carpet",
    image: "https://minecraft.wiki/images/Light_Gray_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "light_gray"
}
export const LightGrayConcrete: BlockType = {
    name: "light_gray_concrete",
    image: "https://minecraft.wiki/images/Light_Gray_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "light_gray"
}
export const LightGrayConcretePowder: BlockType = {
    name: "light_gray_concrete_powder",
    image: "https://minecraft.wiki/images/Light_Gray_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "light_gray"
}
export const LightGrayGlazedTerracotta: BlockType = {
    name: "light_gray_glazed_terracotta",
    image: "https://minecraft.wiki/images/Light_Gray_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "light_gray"
}
export const LightGrayShulkerBox: BlockType = {
    name: "light_gray_shulker_box",
    image: "https://minecraft.wiki/images/Light_Gray_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "light_gray"
}
export const LightGrayStainedGlass: BlockType = {
    name: "light_gray_stained_glass",
    image: "https://minecraft.wiki/images/Light_Gray_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "light_gray"
}
export const LightGrayStainedGlassPane: BlockType = {
    name: "light_gray_stained_glass_pane",
    image: "https://minecraft.wiki/images/Light_Gray_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "light_gray"
}
export const LightGrayStainedTerracotta: BlockType = {
    name: "light_gray_stained_terracotta",
    image: "https://minecraft.wiki/images/Light_Gray_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "light_gray"
}
export const LightGrayWool: BlockType = {
    name: "light_gray_wool",
    image: "https://minecraft.wiki/images/Light_Gray_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "light_gray"
}
export const LightWeightedPressurePlate: BlockType = {
    name: "light_weighted_pressure_plate",
    image: "https://minecraft.wiki/images/Light_Weighted_Pressure_Plate_JE3_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "1.5",
    color: "yellow"
}
export const LightningRod: BlockType = {
    name: "lightning_rod",
    image: "https://minecraft.wiki/images/Lightning_Rod_(U)_JE3.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "orange"
}
export const Lilac: BlockType = {
    name: "lilac",
    image: "https://minecraft.wiki/images/Lilac_JE4_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "magenta"
}
export const LilyoftheValley: BlockType = {
    name: "lily_of_the_valley",
    image: "https://minecraft.wiki/images/Lily_of_the_Valley_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.14",
    color: "white"
}
export const LilyPad: BlockType = {
    name: "lily_pad",
    image: "https://minecraft.wiki/images/Lily_Pad_(on_the_water).png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.0.0",
    color: "dark_green"
}
export const LimeBanner: BlockType = {
    name: "lime_banner",
    image: "https://minecraft.wiki/images/Lime_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "light_gray"
}
export const LimeBed: BlockType = {
    name: "lime_bed",
    image: "https://minecraft.wiki/images/Lime_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "light_green"
}
export const LimeCandle: BlockType = {
    name: "lime_candle",
    image: "https://minecraft.wiki/images/Lime_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "light_green"
}
export const LimeCarpet: BlockType = {
    name: "lime_carpet",
    image: "https://minecraft.wiki/images/Lime_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "light_green"
}
export const LimeConcrete: BlockType = {
    name: "lime_concrete",
    image: "https://minecraft.wiki/images/Lime_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "light_green"
}
export const LimeConcretePowder: BlockType = {
    name: "lime_concrete_powder",
    image: "https://minecraft.wiki/images/Lime_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "light_green"
}
export const LimeGlazedTerracotta: BlockType = {
    name: "lime_glazed_terracotta",
    image: "https://minecraft.wiki/images/Lime_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "light_green"
}
export const LimeShulkerBox: BlockType = {
    name: "lime_shulker_box",
    image: "https://minecraft.wiki/images/Lime_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "light_green"
}
export const LimeStainedGlass: BlockType = {
    name: "lime_stained_glass",
    image: "https://minecraft.wiki/images/Lime_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "light_green"
}
export const LimeStainedGlassPane: BlockType = {
    name: "lime_stained_glass_pane",
    image: "https://minecraft.wiki/images/Lime_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "light_green"
}
export const LimeStainedTerracotta: BlockType = {
    name: "lime_stained_terracotta",
    image: "https://minecraft.wiki/images/Lime_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "light_green"
}
export const LimeWool: BlockType = {
    name: "lime_wool",
    image: "https://minecraft.wiki/images/Lime_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "light_green"
}
export const Lodestone: BlockType = {
    name: "lodestone",
    image: "https://minecraft.wiki/images/Lodestone_JE1_BE1.png",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "1.16",
    color: "light_gray"
}
export const Loom: BlockType = {
    name: "loom",
    image: "https://minecraft.wiki/images/Loom_(S)_JE1_BE1.png",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "1.14",
    color: "light_brown"
}

export const MagentaBanner: BlockType = {
    name: "magenta_banner",
    image: "https://minecraft.wiki/images/Magenta_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "magenta"
}
export const MagentaBed: BlockType = {
    name: "magenta_bed",
    image: "https://minecraft.wiki/images/Magenta_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "magenta"
}
export const MagentaCandle: BlockType = {
    name: "magenta_candle",
    image: "https://minecraft.wiki/images/Magenta_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "magenta"
}
export const MagentaCarpet: BlockType = {
    name: "magenta_carpet",
    image: "https://minecraft.wiki/images/Magenta_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "magenta"
}
export const MagentaConcrete: BlockType = {
    name: "magenta_concrete",
    image: "https://minecraft.wiki/images/Magenta_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "magenta"
}
export const MagentaConcretePowder: BlockType = {
    name: "magenta_concrete_powder",
    image: "https://minecraft.wiki/images/Magenta_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "magenta"
}
export const MagentaGlazedTerracotta: BlockType = {
    name: "magenta_glazed_terracotta",
    image: "https://minecraft.wiki/images/Magenta_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "magenta"
}
export const MagentaShulkerBox: BlockType = {
    name: "magenta_shulker_box",
    image: "https://minecraft.wiki/images/Magenta_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "magenta"
}
export const MagentaStainedGlass: BlockType = {
    name: "magenta_stained_glass",
    image: "https://minecraft.wiki/images/Magenta_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "magenta"
}
export const MagentaStainedGlassPane: BlockType = {
    name: "magenta_stained_glass_pane",
    image: "https://minecraft.wiki/images/Magenta_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "magenta"
}
export const MagentaStainedTerracotta: BlockType = {
    name: "magenta_stained_terracotta",
    image: "https://minecraft.wiki/images/Magenta_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "magenta"
}
export const MagentaWool: BlockType = {
    name: "magenta_wool",
    image: "https://minecraft.wiki/images/Magenta_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "magenta"
}
export const MagmaBlock: BlockType = {
    name: "magma_block",
    image: "https://minecraft.wiki/images/Magma_Block_JE2_BE2.gif",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "1.10",
    color: "orange"
}
export const MangroveButton: BlockType = {
    name: "mangrove_button",
    image: "https://minecraft.wiki/images/Mangrove_Button_JE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.19",
    color: "red"
}
export const MangroveDoor: BlockType = {
    name: "mangrove_door",
    image: "https://minecraft.wiki/images/Mangrove_Door_JE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangroveFence: BlockType = {
    name: "mangrove_fence",
    image: "https://minecraft.wiki/images/Mangrove_Fence_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangroveFenceGate: BlockType = {
    name: "mangrove_fence_gate",
    image: "https://minecraft.wiki/images/Mangrove_Fence_Gate_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangroveHangingSign: BlockType = {
    name: "mangrove_hanging_sign",
    image: "https://minecraft.wiki/images/Mangrove_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "red"
}
export const MangroveLeaves: BlockType = {
    name: "mangrove_leaves",
    image: "https://minecraft.wiki/images/Mangrove_Leaves.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "green",
    color: "green"
}
export const MangroveLog: BlockType = {
    name: "mangrove_log",
    image: "https://minecraft.wiki/images/Mangrove_Log_(UD)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.19",
    color: "brown"
}
export const MangrovePressurePlate: BlockType = {
    name: "mangrove_pressure_plate",
    image: "https://minecraft.wiki/images/Mangrove_Pressure_Plate_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangrovePropagule: BlockType = {
    name: "mangrove_propagule",
    image: "https://minecraft.wiki/images/Mangrove_Propagule_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.19",
    color: "green"
}
export const MangrovePlanks: BlockType = {
    name: "mangrove_planks",
    image: "https://minecraft.wiki/images/Mangrove_Planks_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangroveRoots: BlockType = {
    name: "mangrove_roots",
    image: "https://minecraft.wiki/images/Mangrove_Roots_JE2.png",
    hardness: 0.7,
    blast_resistance: 0.7,
    tool: "Axe",
    version: "1.19",
    color: "brown"
}
export const MangroveSign: BlockType = {
    name: "mangrove_sign",
    image: "https://minecraft.wiki/images/Mangrove_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangroveSlab: BlockType = {
    name: "mangrove_slab",
    image: "https://minecraft.wiki/images/Mangrove_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangroveStairs: BlockType = {
    name: "mangrove_stairs",
    image: "https://minecraft.wiki/images/Mangrove_Stairs_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangroveTrapdoor: BlockType = {
    name: "mangrove_trapdoor",
    image: "https://minecraft.wiki/images/Mangrove_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.19",
    color: "red"
}
export const MangroveWood: BlockType = {
    name: "mangrove_wood",
    image: "https://minecraft.wiki/images/Mangrove_Wood_(UD)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.19",
    color: "brown"
}
export const MediumAmethystBud: BlockType = {
    name: "medium_amethyst_bud",
    image: "https://minecraft.wiki/images/Medium_Amethyst_Bud_(U)_JE1.png",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Pickaxe",
    version: "1.17",
    color: "purple"
}
export const MelonStem: BlockType = {
    name: "melon_stem",
    image: "https://minecraft.wiki/images/Stem_Age_7_JE6.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "None",
    version: "beta",
    color: "brown"
}
export const MonsterSpawner: BlockType = {
    name: "monster_spawner",
    image: "https://minecraft.wiki/images/Spawner_with_fire.png",
    hardness: 5,
    blast_resistance: 5,
    tool: "Pickaxe",
    version: "infdev",
    color: "black"
}
export const MossBlock: BlockType = {
    name: "moss_block",
    image: "https://minecraft.wiki/images/Moss_Block_JE1_BE1.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Hoe",
    version: "1.17",
    color: "green"
}
export const MossCarpet: BlockType = {
    name: "moss_carpet",
    image: "https://minecraft.wiki/images/Moss_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Hoe",
    version: "1.17",
    color: "green"
}
export const MossyCobblestone: BlockType = {
    name: "mossy_cobblestone",
    image: "https://minecraft.wiki/images/Mossy_Cobblestone_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "classic",
    color: "green"
}
export const MossyCobblestoneSlab: BlockType = {
    name: "mossy_cobblestone_slab",
    image: "https://minecraft.wiki/images/Mossy_Cobblestone_Slab_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "green"
}
export const MossyCobblestoneStairs: BlockType = {
    name: "mossy_cobblestone_stairs",
    image: "https://minecraft.wiki/images/Mossy_Cobblestone_Stairs_(N)_JE2_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "green"
}
export const MossyCobblestoneWall: BlockType = {
    name: "mossy_cobblestone_wall",
    image: "https://minecraft.wiki/images/Mossy_Cobblestone_Wall_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.4.2",
    color: "green"
}
export const MossyStoneBrickSlab: BlockType = {
    name: "mossy_stone_brick_slab",
    image: "https://minecraft.wiki/images/Mossy_Stone_Brick_Slab_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "green"
}
export const MossyStoneBrickStairs: BlockType = {
    name: "mossy_stone_brick_stairs",
    image: "https://minecraft.wiki/images/Mossy_Stone_Brick_Stairs_(N)_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "green"
}
export const MossyStoneBrickWall: BlockType = {
    name: "mossy_stone_brick_wall",
    image: "https://minecraft.wiki/images/Mossy_Stone_Brick_Wall_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "green"
}
export const MossyStoneBricks: BlockType = {
    name: "mossy_stone_bricks",
    image: "https://minecraft.wiki/images/Mossy_Stone_Bricks_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "green"
}
export const Mud: BlockType = {
    name: "mud",
    image: "https://minecraft.wiki/images/Mud_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.19",
    color: "dark_brown"
}
export const MudBrickSlab: BlockType = {
    name: "mud_brick_slab",
    image: "https://minecraft.wiki/images/Mud_Brick_Slab_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.19",
    color: "light_brown"
}
export const MudBrickStairs: BlockType = {
    name: "mud_brick_stairs",
    image: "https://minecraft.wiki/images/Mud_Brick_Stairs_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.19",
    color: "light_brown"
}
export const MudBrickWall: BlockType = {
    name: "mud_brick_wall",
    image: "https://minecraft.wiki/images/Mud_Brick_Wall_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.19",
    color: "light_brown"
}
export const MudBricks: BlockType = {
    name: "mud_bricks",
    image: "https://minecraft.wiki/images/Mud_Bricks_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.19",
    color: "light_brown"
}
export const MuddyMangroveRoots: BlockType = {
    name: "muddy_mangrove_roots",
    image: "https://minecraft.wiki/images/Muddy_Mangrove_Roots_JE1_BE1.png",
    hardness: 0.7,
    blast_resistance: 0.7,
    tool: "Shovel",
    version: "1.19",
    color: "dark_brown"
}
export const MushroomStem: BlockType = {
    name: "mushroom_stem",
    image: "https://minecraft.wiki/images/Mushroom_Stem_(ESU)_JE2_BE2.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Axe",
    version: "beta",
    color: "white"
}
export const Mycelium: BlockType = {
    name: "mycelium",
    image: "https://minecraft.wiki/images/Mycelium_JE5_BE3.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Shovel",
    version: "1.0.0",
    color: "brown"
}
export const NetherBrickFence: BlockType = {
    name: "nether_brick_fence",
    image: "https://minecraft.wiki/images/Nether_Brick_Fence_JE3_BE4.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.0.0",
    color: "maroon"
}
export const NetherBrickSlab: BlockType = {
    name: "nether_brick_slab",
    image: "https://minecraft.wiki/images/Nether_Brick_Slab_JE3_BE3.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.4.6",
    color: "maroon"
}
export const NetherBrickStairs: BlockType = {
    name: "nether_brick_stairs",
    image: "https://minecraft.wiki/images/Nether_Brick_Stairs_(N)_JE5_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.0.0",
    color: "maroon"
}
export const NetherBrickWall: BlockType = {
    name: "nether_brick_wall",
    image: "https://minecraft.wiki/images/Nether_Brick_Wall_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "maroon"
}
export const NetherBricks: BlockType = {
    name: "nether_bricks",
    image: "https://minecraft.wiki/images/Nether_Bricks_JE3_BE4.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.0.0",
    color: "maroon"
}
export const NetherGoldOre: BlockType = {
    name: "nether_gold_ore",
    image: "https://minecraft.wiki/images/Nether_Gold_Ore_JE2_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.16",
    color: "yellow"
}
export const NetherPortal: BlockType = {
    name: "nether_portal",
    image: "https://minecraft.wiki/images/Nether_Portal_(EW).gif",
    hardness: -1,
    blast_resistance: -1,
    tool: "None",
    version: "alpha",
    color: "purple"
}
export const NetherQuartzOre: BlockType = {
    name: "nether_quartz_ore",
    image: "https://minecraft.wiki/images/Nether_Quartz_Ore_JE3_BE2.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.5",
    color: "white"
}
export const NetherSprouts: BlockType = {
    name: "nether_sprouts",
    image: "https://minecraft.wiki/images/Nether_Sprouts_JE2_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "1.16",
    color: "cyan"
}
export const NetherWart: BlockType = {
    name: "nether_wart",
    image: "https://minecraft.wiki/images/Nether_Wart_Age_0_JE8.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.0.0",
    color: "red"
}
export const NetherWartBlock: BlockType = {
    name: "nether_wart_block",
    image: "https://minecraft.wiki/images/Nether_Wart_Block_JE3.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Hoe",
    version: "1.10",
    color: "red"
}
export const Netherrack: BlockType = {
    name: "netherrack",
    image: "https://minecraft.wiki/images/Netherrack_JE4_BE2.png",
    hardness: 0.4,
    blast_resistance: 0.4,
    tool: "Pickaxe",
    version: "alpha",
    color: "red"
}
export const NoteBlock: BlockType = {
    name: "note_block",
    image: "https://minecraft.wiki/images/Note_Block_JE2_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Axe",
    version: "beta",
    color: "brown"
}
export const OakButton: BlockType = {
    name: "oak_button",
    image: "https://minecraft.wiki/images/Oak_Button_JE5.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.4.2",
    color: "light_brown"
}
export const OakDoor: BlockType = {
    name: "oak_door",
    image: "https://minecraft.wiki/images/Oak_Door_JE8.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "infdev",
    color: "light_brown"
}
export const OakFence: BlockType = {
    name: "oak_fence",
    image: "https://minecraft.wiki/images/Oak_Fence_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "alpha",
    color: "light_brown"
}
export const OakFenceGate: BlockType = {
    name: "oak_fence_gate",
    image: "https://minecraft.wiki/images/Oak_Fence_Gate_JE4_BE3.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "beta",
    color: "light_brown"
}
export const OakHangingSign: BlockType = {
    name: "oak_hanging_sign",
    image: "https://minecraft.wiki/images/Oak_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "light_brown"
}
export const OakLeaves: BlockType = {
    name: "oak_leaves",
    image: "https://minecraft.wiki/images/Oak_Leaves.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "classic",
    color: "green"
}
export const OakLog: BlockType = {
    name: "oak_log",
    image: "https://minecraft.wiki/images/Oak_Log_(UD)_JE5_BE3.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "classic",
    color: "brown"
}
export const OakPlanks: BlockType = {
    name: "oak_planks",
    image: "https://minecraft.wiki/images/Oak_Planks.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "pre-classic",
    color: "light_brown"
}
export const OakPressurePlate: BlockType = {
    name: "oak_pressure_plate",
    image: "https://minecraft.wiki/images/Oak_Pressure_Plate_JE5_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "alpha",
    color: "light_brown"
}
export const OakSapling: BlockType = {
    name: "oak_sapling",
    image: "https://minecraft.wiki/images/Oak_Sapling_JE14.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "pre-classic",
    color: "green"
}
export const OakSign: BlockType = {
    name: "oak_sign",
    image: "https://minecraft.wiki/images/Oak_Sign_(0).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "classic",
    color: "light_brown"
}
export const OakSlab: BlockType = {
    name: "oak_slab",
    image: "https://minecraft.wiki/images/Oak_Slab_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "beta",
    color: "light_brown"
}
export const OakStairs: BlockType = {
    name: "oak_stairs",
    image: "https://minecraft.wiki/images/Oak_Stairs_(N)_JE7_BE6.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "infdev",
    color: "light_brown"
}
export const OakTrapdoor: BlockType = {
    name: "oak_trapdoor",
    image: "https://minecraft.wiki/images/Oak_Trapdoor_JE4_BE2.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "beta",
    color: "light_brown"
}
export const OakWood: BlockType = {
    name: "oak_wood",
    image: "https://minecraft.wiki/images/Oak_Wood_(UD)_JE5_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "brown"
}
export const Observer: BlockType = {
    name: "observer",
    image: "https://minecraft.wiki/images/Observer_JE4_BE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.11",
    color: "gray"
}
export const Obsidian: BlockType = {
    name: "obsidian",
    image: "https://minecraft.wiki/images/Obsidian_JE3_BE2.png",
    hardness: 50,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "classic",
    color: "black"
}
export const OchreFroglight: BlockType = {
    name: "ochre_froglight",
    image: "https://minecraft.wiki/images/Ochre_Froglight_JE1.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.19",
    color: "yellow"
}
export const OminousBanner: BlockType = {
    name: "ominous_banner",
    image: "https://minecraft.wiki/images/Ominous_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.14",
    color: "gray"
}
export const OrangeBanner: BlockType = {
    name: "orange_banner",
    image: "https://minecraft.wiki/images/Orange_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "orange"
}
export const OrangeBed: BlockType = {
    name: "orange_bed",
    image: "https://minecraft.wiki/images/Orange_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "orange"
}
export const OrangeCandle: BlockType = {
    name: "orange_candle",
    image: "https://minecraft.wiki/images/Orange_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "orange"
}
export const OrangeCarpet: BlockType = {
    name: "orange_carpet",
    image: "https://minecraft.wiki/images/Orange_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "orange"
}
export const OrangeConcrete: BlockType = {
    name: "orange_concrete",
    image: "https://minecraft.wiki/images/Orange_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "orange"
}
export const OrangeConcretePowder: BlockType = {
    name: "orange_concrete_powder",
    image: "https://minecraft.wiki/images/Orange_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "orange"
}
export const OrangeGlazedTerracotta: BlockType = {
    name: "orange_glazed_terracotta",
    image: "https://minecraft.wiki/images/Orange_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "orange"
}
export const OrangeShulkerBox: BlockType = {
    name: "orange_shulker_box",
    image: "https://minecraft.wiki/images/Orange_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "orange"
}
export const OrangeStainedGlass: BlockType = {
    name: "orange_stained_glass",
    image: "https://minecraft.wiki/images/Orange_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "orange"
}
export const OrangeStainedGlassPane: BlockType = {
    name: "orange_stained_glass_pane",
    image: "https://minecraft.wiki/images/Orange_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "orange"
}
export const OrangeStainedTerracotta: BlockType = {
    name: "orange_stained_terracotta",
    image: "https://minecraft.wiki/images/Orange_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "orange"
}
export const OrangeWool: BlockType = {
    name: "orange_wool",
    image: "https://minecraft.wiki/images/Orange_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "orange"
}
export const OrangeTulip: BlockType = {
    name: "orange_tulip",
    image: "https://minecraft.wiki/images/Orange_Tulip_JE7_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Any",
    version: "1.7.2",
    color: "orange"
}
export const OxeyeDaisy: BlockType = {
    name: "oxeye_daisy",
    image: "https://minecraft.wiki/images/Oxeye_Daisy_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "white"
}
export const OxidizedChiseledCopper: BlockType = {
    name: "oxidized_chiseled_copper",
    image: "https://minecraft.wiki/images/Oxidized_Chiseled_Copper_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "cyan"
}
export const OxidizedBlockOfCopper: BlockType = {
    name: "oxidized_copper",
    image: "https://minecraft.wiki/images/Oxidized_Copper_Block_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "cyan"
}
export const OxidizedCopperBulb: BlockType = {
    name: "oxidized_copper_bulb",
    image: "https://minecraft.wiki/images/Oxidized_Copper_Bulb_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "cyan"
}
export const OxidizedCopperDoor: BlockType = {
    name: "oxidized_copper_door",
    image: "https://minecraft.wiki/images/Oxidized_Copper_Bulb_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "cyan"
}
export const OxidizedCopperGrate: BlockType = {
    name: "oxidized_copper_grate",
    image: "https://minecraft.wiki/images/Oxidized_Copper_Grate_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "cyan"
}
export const OxidizedCopperTrapdoor: BlockType = {
    name: "oxidized_copper_trapdoor",
    image: "https://minecraft.wiki/images/Oxidized_Copper_Trapdoor_JE2_BE2.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "cyan"
}
export const OxidizedCutCopper: BlockType = {
    name: "oxidized_cut_copper",
    image: "https://minecraft.wiki/images/Oxidized_Cut_Copper_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "cyan"
}
export const OxidizedCutCopperSlab: BlockType = {
    name: "oxidized_cut_copper_slab",
    image: "https://minecraft.wiki/images/Oxidized_Cut_Copper_Slab_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "cyan"
}
export const OxidizedCutCopperStairs: BlockType = {
    name: "oxidized_cut_copper_stairs",
    image: "https://minecraft.wiki/images/Oxidized_Cut_Copper_Stairs_(N)_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "cyan"
}
export const PackedIce: BlockType = {
    name: "packed_ice",
    image: "https://minecraft.wiki/images/Packed_Ice_JE2_BE3.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "1.7.2",
    color: "light_blue"
}
export const PackedMud: BlockType = {
    name: "packed_mud",
    image: "https://minecraft.wiki/images/Packed_Mud_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.19",
    color: "brown"
}
export const PearlescentFroglight: BlockType = {
    name: "pearlescent_froglight",
    image: "https://minecraft.wiki/images/Pearlescent_Froglight_JE1.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.19",
    color: "purple"
}
export const Peony: BlockType = {
    name: "peony",
    image: "https://minecraft.wiki/images/Peony_JE4_BE3.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "pink"
}
export const PetrifiedOakSlab: BlockType = {
    name: "petrified_oak_slab",
    image: "https://minecraft.wiki/images/Oak_Slab_JE5_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.3",
    color: "light_brown"
}
export const PiglinHead: BlockType = {
    name: "piglin_head",
    image: "https://minecraft.wiki/images/Piglin_Head_(8)_JE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Any",
    version: "1.19.3",
    color: "brown"
}
export const PinkBanner: BlockType = {
    name: "pink_banner",
    image: "https://minecraft.wiki/images/Pink_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "pink"
}
export const PinkBed: BlockType = {
    name: "pink_bed",
    image: "https://minecraft.wiki/images/Pink_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "pink"
}
export const PinkCandle: BlockType = {
    name: "pink_candle",
    image: "https://minecraft.wiki/images/Pink_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "pink"
}
export const PinkCarpet: BlockType = {
    name: "pink_carpet",
    image: "https://minecraft.wiki/images/Pink_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "pink"
}
export const PinkConcrete: BlockType = {
    name: "pink_concrete",
    image: "https://minecraft.wiki/images/Pink_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "pink"
}
export const PinkConcretePowder: BlockType = {
    name: "pink_concrete_powder",
    image: "https://minecraft.wiki/images/Pink_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "pink"
}
export const PinkGlazedTerracotta: BlockType = {
    name: "pink_glazed_terracotta",
    image: "https://minecraft.wiki/images/Pink_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "pink"
}
export const PinkShulkerBox: BlockType = {
    name: "pink_shulker_box",
    image: "https://minecraft.wiki/images/Pink_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "pink"
}
export const PinkStainedGlass: BlockType = {
    name: "pink_stained_glass",
    image: "https://minecraft.wiki/images/Pink_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "pink"
}
export const PinkStainedGlassPane: BlockType = {
    name: "pink_stained_glass_pane",
    image: "https://minecraft.wiki/images/Pink_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "pink"
}
export const PinkStainedTerracotta: BlockType = {
    name: "pink_stained_terracotta",
    image: "https://minecraft.wiki/images/Pink_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "pink"
}
export const PinkWool: BlockType = {
    name: "pink_wool",
    image: "https://minecraft.wiki/images/Pink_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "pink"
}
export const PinkPetals: BlockType = {
    name: "pink_petals",
    image: "https://minecraft.wiki/images/Pink_Petals_4_JE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.19.4",
    color: "pink"
}
export const PitcherPod: BlockType = {
    name: "pitcher_pod",
    image: "https://minecraft.wiki/images/Pitcher_Crop_Age_4_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "None",
    version: "1.20",
    color: "green"
}
export const PitcherPlant: BlockType = {
    name: "pitcher_plant",
    image: "https://minecraft.wiki/images/Pitcher_Plant_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.20",
    color: "light_blue"
}
export const Piston: BlockType = {
    name: "piston",
    image: "https://minecraft.wiki/images/Piston_(U)_JE3.gif",
    hardness: 1.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const PlayerHead: BlockType = {
    name: "player_head",
    image: "https://minecraft.wiki/images/Player_Head_(8)_JE5.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Any",
    version: "1.4.2",
    color: "brown"
}
export const Podzol: BlockType = {
    name: "podzol",
    image: "https://minecraft.wiki/images/Podzol.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.7.2",
    color: "brown"
}
export const PointedDripstone: BlockType = {
    name: "pointed_dripstone",
    image: "https://minecraft.wiki/images/Pointed_Dripstone_Base_(D)_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.17",
    color: "brown"
}
export const PolishedAndesite: BlockType = {
    name: "polished_andesite",
    image: "https://minecraft.wiki/images/Polished_Andesite_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "gray"
}
export const PolishedAndesiteSlab: BlockType = {
    name: "polished_andesite_slab",
    image: "https://minecraft.wiki/images/Polished_Andesite_Slab_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const PolishedAndesiteStairs: BlockType = {
    name: "polished_andesite_stairs",
    image: "https://minecraft.wiki/images/Polished_Andesite_Stairs_(N)_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const PolishedBasalt: BlockType = {
    name: "polished_basalt",
    image: "https://minecraft.wiki/images/Polished_Basalt_(UD)_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.16",
    color: "gray"
}
export const PolishedBlackstone: BlockType = {
    name: "polished_blackstone",
    image: "https://minecraft.wiki/images/Polished_Blackstone_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstoneBrickSlab: BlockType = {
    name: "polished_blackstone_brick_slab",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Brick_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstoneBrickStairs: BlockType = {
    name: "polished_blackstone_brick_stairs",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Brick_Stairs_(N)_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstoneBrickWall: BlockType = {
    name: "polished_blackstone_brick_wall",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Brick_Wall_JE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstoneBricks: BlockType = {
    name: "polished_blackstone_bricks",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Bricks_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstoneButton: BlockType = {
    name: "polished_blackstone_button",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Button_JE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstonePressurePlate: BlockType = {
    name: "polished_blackstone_pressure_plate",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Pressure_Plate_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstoneSlab: BlockType = {
    name: "polished_blackstone_slab",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstoneStairs: BlockType = {
    name: "polished_blackstone_stairs",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Stairs_(N)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedBlackstoneWall: BlockType = {
    name: "polished_blackstone_wall",
    image: "https://minecraft.wiki/images/Polished_Blackstone_Wall_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.16",
    color: "black"
}
export const PolishedDiorite: BlockType = {
    name: "polished_diorite",
    image: "https://minecraft.wiki/images/Polished_Diorite_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "white"
}
export const PolishedDioriteSlab: BlockType = {
    name: "polished_diorite_slab",
    image: "https://minecraft.wiki/images/Polished_Diorite_Slab_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "white"
}
export const PolishedDioriteStairs: BlockType = {
    name: "polished_diorite_stairs",
    image: "https://minecraft.wiki/images/Polished_Diorite_Stairs_(N)_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "white"
}
export const PolishedGranite: BlockType = {
    name: "polished_granite",
    image: "https://minecraft.wiki/images/Polished_Granite_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "light_brown"
}
export const PolishedGraniteSlab: BlockType = {
    name: "polished_granite_slab",
    image: "https://minecraft.wiki/images/Polished_Granite_Slab_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "light_brown"
}
export const PolishedGraniteStairs: BlockType = {
    name: "polished_granite_stairs",
    image: "https://minecraft.wiki/images/Polished_Granite_Stairs_(N)_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "light_brown"
}
export const PolishedDeepslate: BlockType = {
    name: "polished_deepslate",
    image: "https://minecraft.wiki/images/Polished_Deepslate_JE2_BE1.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const PolishedDeepslateSlab: BlockType = {
    name: "polished_deepslate_slab",
    image: "https://minecraft.wiki/images/Polished_Deepslate_Slab_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const PolishedDeepslateStairs: BlockType = {
    name: "polished_deepslate_stairs",
    image: "https://minecraft.wiki/images/Polished_Deepslate_Stairs_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const PolishedDeepslateWall: BlockType = {
    name: "polished_deepslate_wall",
    image: "https://minecraft.wiki/images/Polished_Deepslate_Wall_JE2.png",
    hardness: 3.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const PolishedTuff: BlockType = {
    name: "polished_tuff",
    image: "https://minecraft.wiki/images/Polished_Tuff_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const PolishedTuffSlab: BlockType = {
    name: "polished_tuff_slab",
    image: "https://minecraft.wiki/images/Polished_Tuff_Slab_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const PolishedTuffStairs: BlockType = {
    name: "polished_tuff_stairs",
    image: "https://minecraft.wiki/images/Polished_Tuff_Stairs_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const PolishedTuffWall: BlockType = {
    name: "polished_tuff_wall",
    image: "https://minecraft.wiki/images/Polished_Tuff_Wall_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const Poppy: BlockType = {
    name: "poppy",
    image: "https://minecraft.wiki/images/Poppy_JE8_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "classic",
    color: "red"
}
export const Potato: BlockType = {
    name: "potatoes",
    image: "https://minecraft.wiki/images/Potatoes_Age_7_JE8.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.4.2",
    color: "green"
}
export const PowderSnow: BlockType = {
    name: "powder_snow",
    image: "https://minecraft.wiki/images/Powder_Snow_JE1_BE1.png",
    hardness: 0.25,
    blast_resistance: 0.25,
    tool: "Bucket",
    version: "1.17",
    color: "white"
}
export const PoweredRail: BlockType = {
    name: "powered_rail",
    image: "https://minecraft.wiki/images/Powered_Rail_(NS)_JE2_BE2.png",
    hardness: 0.7,
    blast_resistance: 0.7,
    tool: "Pickaxe",
    version: "1.5",
    color: "yellow"
}
export const Prismarine: BlockType = {
    name: "prismarine",
    image: "https://minecraft.wiki/images/Prismarine_JE2_BE2.gif",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "cyan"
}
export const PrismarineBrickSlab: BlockType = {
    name: "prismarine_brick_slab",
    image: "https://minecraft.wiki/images/Prismarine_Brick_Slab_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "cyan"
}
export const PrismarineBrickStairs: BlockType = {
    name: "prismarine_brick_stairs",
    image: "https://minecraft.wiki/images/Prismarine_Brick_Stairs_(N)_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "cyan"
}
export const PrismarineBricks: BlockType = {
    name: "prismarine_bricks",
    image: "https://minecraft.wiki/images/Prismarine_Bricks_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "cyan"
}
export const PrismarineSlab: BlockType = {
    name: "prismarine_slab",
    image: "https://minecraft.wiki/images/Prismarine_Slab_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "cyan"
}
export const PrismarineStairs: BlockType = {
    name: "prismarine_stairs",
    image: "https://minecraft.wiki/images/Prismarine_Stairs_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "cyan"
}
export const PrismarineWall: BlockType = {
    name: "prismarine_wall",
    image: "https://minecraft.wiki/images/Prismarine_Wall_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "cyan"
}
export const Pumpkin: BlockType = {
    name: "pumpkin",
    image: "https://minecraft.wiki/images/Carved_Pumpkin_(N)_JE5.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "alpha",
    color: "orange"
}
export const PumpkinSeeds: BlockType = {
    name: "pumpkin_seeds",
    image: "https://minecraft.wiki/images/Pumpkin_Stem_Age_7_JE7.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "None",
    version: "beta",
    color: "brown"
}
export const PurpleBanner: BlockType = {
    name: "purple_banner",
    image: "https://minecraft.wiki/images/Purple_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "purple"
}
export const PurpleBed: BlockType = {
    name: "purple_bed",
    image: "https://minecraft.wiki/images/Purple_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "purple"
}
export const PurpleCandle: BlockType = {
    name: "purple_candle",
    image: "https://minecraft.wiki/images/Purple_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "purple"
}
export const PurpleCarpet: BlockType = {
    name: "purple_carpet",
    image: "https://minecraft.wiki/images/Purple_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "purple"
}
export const PurpleConcrete: BlockType = {
    name: "purple_concrete",
    image: "https://minecraft.wiki/images/Purple_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "purple"
}
export const PurpleConcretePowder: BlockType = {
    name: "purple_concrete_powder",
    image: "https://minecraft.wiki/images/Purple_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "purple"
}
export const PurpleGlazedTerracotta: BlockType = {
    name: "purple_glazed_terracotta",
    image: "https://minecraft.wiki/images/Purple_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "purple"
}
export const PurpleShulkerBox: BlockType = {
    name: "purple_shulker_box",
    image: "https://minecraft.wiki/images/Purple_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "purple"
}
export const PurpleStainedGlass: BlockType = {
    name: "purple_stained_glass",
    image: "https://minecraft.wiki/images/Purple_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "purple"
}
export const PurpleStainedGlassPane: BlockType = {
    name: "purple_stained_glass_pane",
    image: "https://minecraft.wiki/images/Purple_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "purple"
}
export const PurpleStainedTerracotta: BlockType = {
    name: "purple_stained_terracotta",
    image: "https://minecraft.wiki/images/Purple_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "purple"
}
export const PurpleWool: BlockType = {
    name: "purple_wool",
    image: "https://minecraft.wiki/images/Purple_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "purple"
}
export const PurpurBlock: BlockType = {
    name: "purpur_block",
    image: "https://minecraft.wiki/images/Purpur_Block_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.9",
    color: "purple"
}
export const PurpurPillar: BlockType = {
    name: "purpur_pillar",
    image: "https://minecraft.wiki/images/Purpur_Pillar_(UD)_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.9",
    color: "purple"
}
export const PurpurSlab: BlockType = {
    name: "purpur_slab",
    image: "https://minecraft.wiki/images/Purpur_Slab_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.9",
    color: "purple"
}
export const PurpurStairs: BlockType = {
    name: "purpur_stairs",
    image: "https://minecraft.wiki/images/Purpur_Stairs_(N)_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.9",
    color: "purple"
}
export const QuartzBricks: BlockType = {
    name: "quartz_bricks",
    image: "https://minecraft.wiki/images/Quartz_Bricks_JE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.16",
    color: "white"
}
export const QuartzPillar: BlockType = {
    name: "quartz_pillar",
    image: "https://minecraft.wiki/images/Quartz_Pillar_(UD)_JE3_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.5",
    color: "white"
}
export const QuartzSlab: BlockType = {
    name: "quartz_slab",
    image: "https://minecraft.wiki/images/Quartz_Slab_JE3_BE3.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.5",
    color: "white"
}
export const QuartzStairs: BlockType = {
    name: "quartz_stairs",
    image: "https://minecraft.wiki/images/Quartz_Stairs_(N)_JE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.5",
    color: "white"
}
export const Rail: BlockType = {
    name: "rail",
    image: "https://minecraft.wiki/images/Rail_(NS)_JE3_BE2.png",
    hardness: 0.7,
    blast_resistance: 0.7,
    tool: "Pickaxe",
    version: "infdev",
    color: "brown"
}
export const RedBanner: BlockType = {
    name: "red_banner",
    image: "https://minecraft.wiki/images/Red_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "red"
}
export const RedBed: BlockType = {
    name: "red_bed",
    image: "https://minecraft.wiki/images/Red_Bed_(N).png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "beta",
    color: "red"
}
export const RedCandle: BlockType = {
    name: "red_candle",
    image: "https://minecraft.wiki/images/Red_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "red"
}
export const RedCarpet: BlockType = {
    name: "red_carpet",
    image: "https://minecraft.wiki/images/Red_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "red"
}
export const RedConcrete: BlockType = {
    name: "red_concrete",
    image: "https://minecraft.wiki/images/Red_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "red"
}
export const RedConcretePowder: BlockType = {
    name: "red_concrete_powder",
    image: "https://minecraft.wiki/images/Red_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "red"
}
export const RedGlazedTerracotta: BlockType = {
    name: "red_glazed_terracotta",
    image: "https://minecraft.wiki/images/Red_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "red"
}
export const RedMushroom: BlockType = {
    name: "red_mushroom",
    image: "https://minecraft.wiki/images/Red_Mushroom_JE9.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "classic",
    color: "red"
}
export const RedMushroomBlock: BlockType = {
    name: "red_mushroom_block",
    image: "https://minecraft.wiki/images/Red_Mushroom_Block_(ESU)_JE2_BE2.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Axe",
    version: "beta",
    color: "red"
}
export const RedNetherBrickSlab: BlockType = {
    name: "red_nether_brick_slab",
    image: "https://minecraft.wiki/images/Red_Nether_Brick_Slab_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "dark_red"
}
export const RedNetherBrickStairs: BlockType = {
    name: "red_nether_brick_stairs",
    image: "https://minecraft.wiki/images/Red_Nether_Brick_Stairs_(N)_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "dark_red"
}
export const RedNetherBrickWall: BlockType = {
    name: "red_nether_brick_wall",
    image: "https://minecraft.wiki/images/Red_Nether_Brick_Wall_JE2_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "dark_red"
}
export const RedNetherBricks: BlockType = {
    name: "red_nether_bricks",
    image: "https://minecraft.wiki/images/Red_Nether_Bricks_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.10",
    color: "dark_red"
}
export const RedSand: BlockType = {
    name: "red_sand",
    image: "https://minecraft.wiki/images/Red_Sand_JE3_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.7.2",
    color: "orange"
}
export const RedSandstone: BlockType = {
    name: "red_sandstone",
    image: "https://minecraft.wiki/images/Red_Sandstone_JE4_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.8",
    color: "orange"
}
export const RedSandstoneSlab: BlockType = {
    name: "red_sandstone_slab",
    image: "https://minecraft.wiki/images/Red_Sandstone_Slab_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "orange"
}
export const RedSandstoneStairs: BlockType = {
    name: "red_sandstone_stairs",
    image: "https://minecraft.wiki/images/Red_Sandstone_Stairs_(N)_JE4_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.8",
    color: "orange"
}
export const RedSandstoneWall: BlockType = {
    name: "red_sandstone_wall",
    image: "https://minecraft.wiki/images/Red_Sandstone_Wall_JE2_BE1.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.14",
    color: "orange"
}
export const RedShulkerBox: BlockType = {
    name: "red_shulker_box",
    image: "https://minecraft.wiki/images/Red_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "red"
}
export const RedStainedGlass: BlockType = {
    name: "red_stained_glass",
    image: "https://minecraft.wiki/images/Red_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "red"
}
export const RedStainedGlassPane: BlockType = {
    name: "red_stained_glass_pane",
    image: "https://minecraft.wiki/images/Red_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "red"
}
export const RedStainedTerracotta: BlockType = {
    name: "red_stained_terracotta",
    image: "https://minecraft.wiki/images/Red_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "red"
}
export const RedTulip: BlockType = {
    name: "red_tulip",
    image: "https://minecraft.wiki/images/Red_Tulip_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "red"
}
export const RedWool: BlockType = {
    name: "red_wool",
    image: "https://minecraft.wiki/images/Red_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "red"
}
export const RedstoneComparator: BlockType = {
    name: "redstone_comparator",
    image: "https://minecraft.wiki/images/Redstone_Comparator_(S)_JE5.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.5",
    color: "light_gray"
}
export const RedstoneLamp: BlockType = {
    name: "redstone_lamp",
    image: "https://minecraft.wiki/images/Redstone_Lamp_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.2.1",
    color: "brown"
}
export const RedstoneOre: BlockType = {
    name: "redstone_ore",
    image: "https://minecraft.wiki/images/Redstone_Ore_JE4_BE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "alpha",
    color: "red"
}
export const RedstoneRepeater: BlockType = {
    name: "redstone_repeater",
    image: "https://minecraft.wiki/images/Redstone_Repeater_(S)_JE5_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "beta",
    color: "light_gray"
}
export const RedstoneTorch: BlockType = {
    name: "redstone_torch",
    image: "https://minecraft.wiki/images/Redstone_Torch_JE5.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "alpha",
    color: "brown"
}
export const RedstoneDust: BlockType = {
    name: "redstone_dust",
    image: "https://minecraft.wiki/images/Inactive_Redstone_Wire_(NESW)_JE4.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "alpha",
    color: "red"
}
export const ReinforcedDeepslate: BlockType = {
    name: "reinforced_deepslate",
    image: "https://minecraft.wiki/images/Reinforced_Deepslate_JE1.png",
    hardness: 55,
    blast_resistance: 1200,
    tool: "None",
    version: "1.19",
    color: "dark_gray"
}
export const RepeatingCommandBlock: BlockType = {
    name: "repeating_command_block",
    image: "https://minecraft.wiki/images/Repeating_Command_Block.gif",
    hardness: -1,
    blast_resistance: 3600000,
    tool: "None",
    version: "1.9",
    color: "purple"
}
export const RespawnAnchor: BlockType = {
    name: "respawn_anchor",
    image: "https://minecraft.wiki/images/Respawn_Anchor_(0)_JE1.png",
    hardness: 50,
    blast_resistance: 1200,
    tool: "Pickaxe",
    version: "1.16",
    color: "purple"
}
export const ResinBricks: BlockType = {
    name: "resin_bricks",
    image: "https://minecraft.wiki/images/Resin_Bricks_JE1_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.21.4",
    color: "orange"
}
export const ResinBrickSlab: BlockType = {
    name: "resin_brick_slab",
    image: "https://minecraft.wiki/images/Resin_Brick_Slab_JE1_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.21.4",
    color: "orange"
}
export const ResinBrickStairs: BlockType = {
    name: "resin_brick_stairs",
    image: "https://minecraft.wiki/images/Resin_Brick_Stairs_JE1_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.21.4",
    color: "orange"
}
export const ResinBrickWall: BlockType = {
    name: "resin_brick_wall",
    image: "https://minecraft.wiki/images/Resin_Brick_Wall_JE1_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.21.4",
    color: "orange"
}
export const RootedDirt: BlockType = {
    name: "rooted_dirt",
    image: "https://minecraft.wiki/images/Rooted_Dirt_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.17",
    color: "brown"
}
export const RoseBush: BlockType = {
    name: "rose_bush",
    image: "https://minecraft.wiki/images/Rose_Bush_JE4_BE3.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "red"
}
export const Sandstone: BlockType = {
    name: "sandstone",
    image: "https://minecraft.wiki/images/Sandstone_JE6_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "beta",
    color: "cream"
}
export const SandstoneSlab: BlockType = {
    name: "sandstone_slab",
    image: "https://minecraft.wiki/images/Sandstone_Slab_JE5_BE6.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "cream"
}
export const SandstoneStairs: BlockType = {
    name: "sandstone_stairs",
    image: "https://minecraft.wiki/images/Sandstone_Stairs_(N)_JE6_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.3.1",
    color: "cream"
}
export const SandstoneWall: BlockType = {
    name: "sandstone_wall",
    image: "https://minecraft.wiki/images/Sandstone_Wall_JE2_BE1.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Pickaxe",
    version: "1.14",
    color: "cream"
}
export const Scaffolding: BlockType = {
    name: "scaffolding",
    image: "https://minecraft.wiki/images/Standing_Scaffolding_JE3.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.14",
    color: "light_brown"
}
export const Sculk: BlockType = {
    name: "sculk",
    image: "https://minecraft.wiki/images/Sculk_JE1_BE1.gif",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Hoe",
    version: "1.19",
    color: "dark_blue"
}
export const SculkCatalyst: BlockType = {
    name: "sculk_catalyst",
    image: "https://minecraft.wiki/images/Sculk_Catalyst_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Hoe",
    version: "1.19",
    color: "dark_blue"
}
export const SculkSensor: BlockType = {
    name: "sculk_sensor",
    image: "https://minecraft.wiki/images/Sculk_Sensor_JE1.gif",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Hoe",
    version: "1.17",
    color: "dark_blue"
}
export const SculkShrieker: BlockType = {
    name: "sculk_shrieker",
    image: "https://minecraft.wiki/images/Sculk_Shrieker_JE2_BE3.gif",
    hardness: 3,
    blast_resistance: 3,
    tool: "Hoe",
    version: "1.19",
    color: "dark_blue"
}
export const SculkVein: BlockType = {
    name: "sculk_vein",
    image: "https://minecraft.wiki/images/Sculk_Vein_JE1_BE1.gif",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Hoe",
    version: "1.19",
    color: "dark_blue"
}
export const SeaLantern: BlockType = {
    name: "sea_lantern",
    image: "https://minecraft.wiki/images/Sea_Lantern_JE1.gif",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.8",
    color: "light_blue"
}
export const SeaPickle: BlockType = {
    name: "sea_pickle",
    image: "https://minecraft.wiki/images/Sea_Pickle_1_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "dark_green"
}
export const Seagrass: BlockType = {
    name: "seagrass",
    image: "https://minecraft.wiki/images/Seagrass_JE1_BE2.gif",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "1.13",
    color: "light_green"
}
export const ShortGrass: BlockType = {
    name: "short_grass",
    image: "https://minecraft.wiki/images/Short_Grass.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "beta",
    color: "green"
}
export const Shroomlight: BlockType = {
    name: "shroomlight",
    image: "https://minecraft.wiki/images/Shroomlight_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Hoe",
    version: "1.16",
    color: "orange"
}
export const ShulkerBox: BlockType = {
    name: "shulker_box",
    image: "https://minecraft.wiki/images/Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "purple"
}
export const SkeletonSkull: BlockType = {
    name: "skeleton_skull",
    image: "https://minecraft.wiki/images/Skeleton_Skull_(8).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Any",
    version: "1.4.2",
    color: "light_gray"
}
export const SlimeBlock: BlockType = {
    name: "slime_block",
    image: "https://minecraft.wiki/images/Slime_Block_JE2_BE3.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.8",
    color: "green"
}
export const SmallAmethystCluster: BlockType = {
    name: "small_amethyst_cluster",
    image: "https://minecraft.wiki/images/Small_Amethyst_Bud_(U)_JE1.png",
    hardness: 1.5,
    blast_resistance: 1.5,
    tool: "Pickaxe",
    version: "1.17",
    color: "purple"
}
export const SmallDripleaf: BlockType = {
    name: "small_dripleaf",
    image: "https://minecraft.wiki/images/Small_Dripleaf_JE3.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "1.17",
    color: "green"
}
export const SmithingTable: BlockType = {
    name: "smithing_table",
    image: "https://minecraft.wiki/images/Smithing_Table_JE2_BE2.png",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "1.14",
    color: "black"
}
export const Smoker: BlockType = {
    name: "smoker",
    image: "https://minecraft.wiki/images/Smoker_(S)_JE2.png",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "1.14",
    color: "brown"
}
export const SmoothBasalt: BlockType = {
    name: "smooth_basalt",
    image: "https://minecraft.wiki/images/Smooth_Basalt_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.17",
    color: "dark_gray"
}
export const SmoothQuartzBlock: BlockType = {
    name: "smooth_quartz_block",
    image: "https://minecraft.wiki/images/Smooth_Quartz_Block_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.5",
    color: "white"
}
export const SmoothQuartzSlab: BlockType = {
    name: "smooth_quartz_slab",
    image: "https://minecraft.wiki/images/Smooth_Quartz_Slab_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "white"
}
export const SmoothQuartzStairs: BlockType = {
    name: "smooth_quartz_stairs",
    image: "https://minecraft.wiki/images/Smooth_Quartz_Stairs_(N)_JE2_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "white"
}
export const SmoothRedSandstone: BlockType = {
    name: "smooth_red_sandstone",
    image: "https://minecraft.wiki/images/Smooth_Red_Sandstone_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "orange"
}
export const SmoothRedSandstoneSlab: BlockType = {
    name: "smooth_red_sandstone_slab",
    image: "https://minecraft.wiki/images/Smooth_Red_Sandstone_Slab_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "orange"
}
export const SmoothRedSandstoneStairs: BlockType = {
    name: "smooth_red_sandstone_stairs",
    image: "https://minecraft.wiki/images/Smooth_Red_Sandstone_Stairs_(N)_JE3_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "orange"
}
export const SmoothSandstone: BlockType = {
    name: "smooth_sandstone",
    image: "https://minecraft.wiki/images/Smooth_Sandstone_JE5_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.5",
    color: "cream"
}
export const SmoothSandstoneSlab: BlockType = {
    name: "smooth_sandstone_slab",
    image: "https://minecraft.wiki/images/Smooth_Sandstone_Slab_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "cream"
}
export const SmoothSandstoneStairs: BlockType = {
    name: "smooth_sandstone_stairs",
    image: "https://minecraft.wiki/images/Smooth_Sandstone_Stairs_(N)_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "cream"
}
export const SmoothStone: BlockType = {
    name: "smooth_stone",
    image: "https://minecraft.wiki/images/Smooth_Stone_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "light_gray"
}
export const SmoothStoneSlab: BlockType = {
    name: "smooth_stone_slab",
    image: "https://minecraft.wiki/images/Smooth_Stone_Slab_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "classic",
    color: "light_gray"
}
export const SnifferEgg: BlockType = {
    name: "sniffer_egg",
    image: "https://minecraft.wiki/images/Sniffer_Egg_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "None",
    version: "1.20",
    color: "green"
}
export const Snow: BlockType = {
    name: "snow",
    image: "https://minecraft.wiki/images/Snow_(layers_1)_JE3_BE3.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Shovel",
    version: "alpha",
    color: "white"
}
export const SnowBlock: BlockType = {
    name: "snow_block",
    image: "https://minecraft.wiki/images/Snow_Block_JE2_BE2.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shovel",
    version: "alpha",
    color: "white"
}
export const SoulCampfire: BlockType = {
    name: "soul_campfire",
    image: "https://minecraft.wiki/images/Soul_Campfire_JE1_BE1.gif",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.16",
    color: "brown"
}
export const SoulFire: BlockType = {
    name: "soul_fire",
    image: "https://minecraft.wiki/images/Soul_Fire_JE1.gif",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.16",
    color: "light_blue"
}
export const SoulLantern: BlockType = {
    name: "soul_lantern",
    image: "https://minecraft.wiki/images/Soul_Lantern_JE2_BE1.gif",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "1.16",
    color: "light_blue"
}
export const SoulSand: BlockType = {
    name: "soul_sand",
    image: "https://minecraft.wiki/images/Soul_Sand_JE2_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "alpha",
    color: "brown"
}
export const SoulSoil: BlockType = {
    name: "soul_soil",
    image: "https://minecraft.wiki/images/Soul_Soil_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.16",
    color: "brown"
}
export const SoulTorch: BlockType = {
    name: "soul_torch",
    image: "https://minecraft.wiki/images/Soul_Torch.gif",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.16",
    color: "brown"
}
export const Sponge: BlockType = {
    name: "sponge",
    image: "https://minecraft.wiki/images/Sponge_JE3_BE3.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Hoe",
    version: "classic",
    color: "yellow"
}
export const SporeBlossom: BlockType = {
    name: "spore_blossom",
    image: "https://minecraft.wiki/images/Spore_Blossom_JE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.17",
    color: "pink"
}
export const SpruceButton: BlockType = {
    name: "spruce_button",
    image: "https://minecraft.wiki/images/Spruce_Button_JE5.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.13",
    color: "brown"
}
export const SpruceDoor: BlockType = {
    name: "spruce_door",
    image: "https://minecraft.wiki/images/Spruce_Door_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "brown"
}
export const SpruceFence: BlockType = {
    name: "spruce_fence",
    image: "https://minecraft.wiki/images/Spruce_Fence_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "brown"
}
export const SpruceFenceGate: BlockType = {
    name: "spruce_fence_gate",
    image: "https://minecraft.wiki/images/Spruce_Fence_Gate_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.8",
    color: "brown"
}
export const SpruceHangingSign: BlockType = {
    name: "spruce_hanging_sign",
    image: "https://minecraft.wiki/images/Spruce_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "brown"
}
export const SpruceLeaves: BlockType = {
    name: "spruce_leaves",
    image: "https://minecraft.wiki/images/Spruce_Leaves_JE1_BE2.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "beta",
    color: "dark_green"
}
export const SpruceLog: BlockType = {
    name: "spruce_log",
    image: "https://minecraft.wiki/images/Spruce_Log_(UD)_JE5_BE3.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "beta",
    color: "dark_brown"
}
export const SprucePlanks: BlockType = {
    name: "spruce_planks",
    image: "https://minecraft.wiki/images/Spruce_Planks_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.2.4",
    color: "brown"
}
export const SprucePressurePlate: BlockType = {
    name: "spruce_pressure_plate",
    image: "https://minecraft.wiki/images/Spruce_Pressure_Plate_JE4_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.13",
    color: "brown"
}
export const SpruceSapling: BlockType = {
    name: "spruce_sapling",
    image: "https://minecraft.wiki/images/Spruce_Sapling_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "beta",
    color: "dark_green"
}
export const SpruceSign: BlockType = {
    name: "spruce_sign",
    image: "https://minecraft.wiki/images/Spruce_Standing_Sign_(S)_JE2_BE2.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.14",
    color: "brown"
}
export const SpruceSlab: BlockType = {
    name: "spruce_slab",
    image: "https://minecraft.wiki/images/Spruce_Slab_JE4_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.3.1",
    color: "brown"
}
export const SpruceStairs: BlockType = {
    name: "spruce_stairs",
    image: "https://minecraft.wiki/images/Spruce_Stairs_(N)_JE5_BE2.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.3.1",
    color: "brown"
}
export const SpruceTrapdoor: BlockType = {
    name: "spruce_trapdoor",
    image: "https://minecraft.wiki/images/Spruce_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.13",
    color: "brown"
}
export const SpruceWood: BlockType = {
    name: "spruce_wood",
    image: "https://minecraft.wiki/images/Spruce_Wood_(UD)_JE4.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "dark_brown"
}
export const StickyPiston: BlockType = {
    name: "sticky_piston",
    image: "https://minecraft.wiki/images/Sticky_Piston_(U)_JE3.gif",
    hardness: 1.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const StoneBrickSlab: BlockType = {
    name: "stone_brick_slab",
    image: "https://minecraft.wiki/images/Stone_Brick_Slab_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "gray"
}
export const StoneBrickStairs: BlockType = {
    name: "stone_brick_stairs",
    image: "https://minecraft.wiki/images/Stone_Brick_Stairs_(N)_JE5_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.8",
    color: "gray"
}
export const StoneBrickWall: BlockType = {
    name: "stone_brick_wall",
    image: "https://minecraft.wiki/images/Stone_Brick_Wall_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const StoneBricks: BlockType = {
    name: "stone_bricks",
    image: "https://minecraft.wiki/images/Stone_Bricks_JE3_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "beta",
    color: "gray"
}
export const StoneButton: BlockType = {
    name: "stone_button",
    image: "https://minecraft.wiki/images/Stone_Button_JE6.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "alpha",
    color: "gray"
}
export const StonePressurePlate: BlockType = {
    name: "stone_pressure_plate",
    image: "https://minecraft.wiki/images/Stone_Pressure_Plate_JE5_BE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Pickaxe",
    version: "alpha",
    color: "gray"
}
export const StoneSlab: BlockType = {
    name: "stone_slab",
    image: "https://minecraft.wiki/images/Stone_Slab_JE2_BE1.png",
    hardness: 2,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const StoneStairs: BlockType = {
    name: "stone_stairs",
    image: "https://minecraft.wiki/images/Stone_Stairs_(N)_JE2_BE2.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const Stonecutter: BlockType = {
    name: "stonecutter",
    image: "https://minecraft.wiki/images/Stonecutter_JE2_BE1.gif",
    hardness: 3.5,
    blast_resistance: 3.5,
    tool: "Pickaxe",
    version: "1.14",
    color: "gray"
}
export const StrippedAcaciaLog: BlockType = {
    name: "stripped_acacia_log",
    image: "https://minecraft.wiki/images/Stripped_Acacia_Log_(UD)_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "orange"
}
export const StrippedAcaciaWood: BlockType = {
    name: "stripped_acacia_wood",
    image: "https://minecraft.wiki/images/Stripped_Acacia_Wood_(UD)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "orange"
}
export const StrippedBirchLog: BlockType = {
    name: "stripped_birch_log",
    image: "https://minecraft.wiki/images/Stripped_Birch_Log_(UD)_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "cream"
}
export const StrippedBirchWood: BlockType = {
    name: "stripped_birch_wood",
    image: "https://minecraft.wiki/images/Stripped_Birch_Wood_(UD)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "cream"
}
export const StrippedCherryLog: BlockType = {
    name: "stripped_cherry_log",
    image: "https://minecraft.wiki/images/Stripped_Cherry_Log_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "pink"
}
export const StrippedCherryWood: BlockType = {
    name: "stripped_cherry_wood",
    image: "https://minecraft.wiki/images/Stripped_Cherry_Wood_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "pink"
}
export const StrippedCrimsonHyphae: BlockType = {
    name: "stripped_crimson_hyphae",
    image: "https://minecraft.wiki/images/Stripped_Crimson_Hyphae_(UD)_JE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "maroon"
}
export const StrippedCrimsonStem: BlockType = {
    name: "stripped_crimson_stem",
    image: "https://minecraft.wiki/images/Stripped_Crimson_Stem_(UD)_JE2_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "maroon"
}
export const StrippedDarkOakLog: BlockType = {
    name: "stripped_dark_oak_log",
    image: "https://minecraft.wiki/images/Stripped_Dark_Oak_Log_(UD)_JE4_BE4.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "dark_brown"
}
export const StrippedDarkOakWood: BlockType = {
    name: "stripped_dark_oak_wood",
    image: "https://minecraft.wiki/images/Stripped_Dark_Oak_Wood_(UD)_JE3_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "dark_brown"
}
export const StrippedJungleLog: BlockType = {
    name: "stripped_jungle_log",
    image: "https://minecraft.wiki/images/Stripped_Jungle_Log_(UD)_JE4_BE3.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "brown"
}
export const StrippedJungleWood: BlockType = {
    name: "stripped_jungle_wood",
    image: "https://minecraft.wiki/images/Stripped_Jungle_Wood_(UD)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "brown"
}
export const StrippedMangroveLog: BlockType = {
    name: "stripped_mangrove_log",
    image: "https://minecraft.wiki/images/Stripped_Mangrove_Log_(UD)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "dark_red"
}
export const StrippedMangroveWood: BlockType = {
    name: "stripped_mangrove_wood",
    image: "https://minecraft.wiki/images/Stripped_Mangrove_Wood_(UD)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "dark_red"
}
export const StrippedOakLog: BlockType = {
    name: "stripped_oak_log",
    image: "https://minecraft.wiki/images/Stripped_Oak_Log_(UD)_JE2_BE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "light_brown"
}
export const StrippedOakWood: BlockType = {
    name: "stripped_oak_wood",
    image: "https://minecraft.wiki/images/Stripped_Oak_Wood_(UD)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "light_brown"
}
export const StrippedSpruceLog: BlockType = {
    name: "stripped_spruce_log",
    image: "https://minecraft.wiki/images/Stripped_Spruce_Log_(UD)_JE2.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "brown"
}
export const StrippedSpruceWood: BlockType = {
    name: "stripped_spruce_wood",
    image: "https://minecraft.wiki/images/Stripped_Spruce_Wood_(UD)_JE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "brown"
}
export const StrippedWarpedHyphae: BlockType = {
    name: "stripped_warped_hyphae",
    image: "https://minecraft.wiki/images/Stripped_Warped_Hyphae_(UD)_JE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "cyan"
}
export const StrippedWarpedStem: BlockType = {
    name: "stripped_warped_stem",
    image: "https://minecraft.wiki/images/Stripped_Warped_Stem_(UD)_JE2_BE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.13",
    color: "cyan"
}
export const StructureBlock: BlockType = {
    name: "structure_block",
    image: "https://minecraft.wiki/images/Structure_Block_JE2_BE1.png",
    hardness: -1,
    blast_resistance: 3600000,
    tool: "None",
    version: "1.9",
    color: "purple"
}
export const StructureVoid: BlockType = {
    name: "structure_void",
    image: "https://minecraft.wiki/images/Structure_Void_(item)_JE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "None",
    version: "1.10",
    color: "none"
}
export const SugarCane: BlockType = {
    name: "sugar_cane",
    image: "https://minecraft.wiki/images/Sugar_Cane.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "alpha",
    color: "green"
}
export const Sunflower: BlockType = {
    name: "sunflower",
    image: "https://minecraft.wiki/images/Sunflower_JE2_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "yellow"
}
export const SuspiciousGravel: BlockType = {
    name: "suspicious_gravel",
    image: "https://minecraft.wiki/images/Suspicious_Gravel_BE1_(dusted_0).png",
    hardness: 0.25,
    blast_resistance: 0.25,
    tool: "Brush",
    version: "1.20",
    color: "gray"
}
export const SuspiciousSand: BlockType = {
    name: "suspicious_sand",
    image: "https://minecraft.wiki/images/Suspicious_Sand_(dusted_0)_JE1_BE1.png",
    hardness: 0.25,
    blast_resistance: 0.25,
    tool: "Brush",
    version: "1.19.4",
    color: "cream"
}
export const SweetBerryBush: BlockType = {
    name: "sweet_berry_bush",
    image: "https://minecraft.wiki/images/Sweet_Berry_Bush_Age_3_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.14",
    color: "red"
}
export const TallGrass: BlockType = {
    name: "tall_grass",
    image: "https://minecraft.wiki/images/Tall_Grass.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "1.7.2",
    color: "green"
}
export const TallSeagrass: BlockType = {
    name: "tall_seagrass",
    image: "https://minecraft.wiki/images/Tall_Seagrass_JE1_BE2.gif",
    hardness: 0,
    blast_resistance: 0,
    tool: "Shears",
    version: "1.13",
    color: "light_green"
}
export const Target: BlockType = {
    name: "target",
    image: "https://minecraft.wiki/images/Target_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Hoe",
    version: "1.16",
    color: "red"
}
export const Terracotta: BlockType = {
    name: "terracotta",
    image: "https://minecraft.wiki/images/Terracotta_JE2_BE2.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "orange"
}
export const TintedGlass: BlockType = {
    name: "tinted_glass",
    image: "https://minecraft.wiki/images/Tinted_Glass_JE2_BE1.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.17",
    color: "black"
}
export const TNT: BlockType = {
    name: "tnt",
    image: "https://minecraft.wiki/images/TNT_JE3_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "classic",
    color: "red"
}
export const Torch: BlockType = {
    name: "torch",
    image: "https://minecraft.wiki/images/Torch.gif",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "indev",
    color: "brown"
}
export const Torchflower: BlockType = {
    name: "torchflower",
    image: "https://minecraft.wiki/images/Torchflower_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.19.4",
    color: "orange"
}
export const TorchflowerSeeds: BlockType = {
    name: "torchflower_seeds",
    image: "https://minecraft.wiki/images/Torchflower_Age_0.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "None",
    version: "1.19.4",
    color: "green"
}
export const TrappedChest: BlockType = {
    name: "trapped_chest",
    image: "https://minecraft.wiki/images/Trapped_Chest.gif",
    hardness: 2.5,
    blast_resistance: 2.5,
    tool: "Axe",
    version: "1.5",
    color: "brown"
}
export const TrialSpawner: BlockType = {
    name: "trial_spawner",
    image: "https://minecraft.wiki/images/Trial_Spawner_JE4_BE3.png",
    hardness: 50,
    blast_resistance: 50,
    tool: "None",
    version: "1.20.3",
    color: "blue"
}
export const Tripwire: BlockType = {
    name: "tripwire",
    image: "https://minecraft.wiki/images/Tripwire_(NESW).png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.3.1",
    color: "gray"
}
export const TripwireHook: BlockType = {
    name: "tripwire_hook",
    image: "https://minecraft.wiki/images/Tripwire_Hook_(S)_JE6_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.3.1",
    color: "light_brown"
}
export const TubeCoral: BlockType = {
    name: "tube_coral",
    image: "https://minecraft.wiki/images/Tube_Coral_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "blue"
}
export const TubeCoralBlock: BlockType = {
    name: "tube_coral_block",
    image: "https://minecraft.wiki/images/Tube_Coral_Block_JE2_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.13",
    color: "blue"
}
export const TubeCoralFan: BlockType = {
    name: "tube_coral_fan",
    image: "https://minecraft.wiki/images/Tube_Coral_Fan_JE1_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.13",
    color: "blue"
}
export const Tuff: BlockType = {
    name: "tuff",
    image: "https://minecraft.wiki/images/Tuff.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "gray"
}
export const TuffBrickSlab: BlockType = {
    name: "tuff_brick_slab",
    image: "https://minecraft.wiki/images/Tuff_Brick_Slab_JE3_BE3.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const TuffBrickStairs: BlockType = {
    name: "tuff_brick_stairs",
    image: "https://minecraft.wiki/images/Tuff_Brick_Stairs_JE3_BE3.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const TuffBrickWall: BlockType = {
    name: "tuff_brick_wall",
    image: "https://minecraft.wiki/images/Tuff_Brick_Wall_JE3_BE3.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const TuffBricks: BlockType = {
    name: "tuff_bricks",
    image: "https://minecraft.wiki/images/Tuff_Bricks_JE3_BE3.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const TuffSlab: BlockType = {
    name: "tuff_slab",
    image: "https://minecraft.wiki/images/Tuff_Slab_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const TuffStairs: BlockType = {
    name: "tuff_stairs",
    image: "https://minecraft.wiki/images/Tuff_Stairs_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const TuffWall: BlockType = {
    name: "tuff_wall",
    image: "https://minecraft.wiki/images/Tuff_Wall_JE1_BE1.png",
    hardness: 1.5,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "gray"
}
export const TurtleEgg: BlockType = {
    name: "turtle_egg",
    image: "https://minecraft.wiki/images/Turtle_Egg_1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.13",
    color: "cream"
}
export const TwistingVines: BlockType = {
    name: "twisting_vines",
    image: "https://minecraft.wiki/images/Twisting_Vines_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.16",
    color: "cyan"
}
export const Vault: BlockType = {
    name: "vault",
    image: "https://minecraft.wiki/images/Vault_(active)_JE5_BE5.png",
    hardness: 50,
    blast_resistance: 50,
    tool: "None",
    version: "1.20.5",
    color: "dark_blue"
}
export const VerdantFroglight: BlockType = {
    name: "verdant_froglight",
    image: "https://minecraft.wiki/images/Verdant_Froglight_JE1.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.19",
    color: "green"
}
export const Vines: BlockType = {
    name: "vines",
    image: "https://minecraft.wiki/images/Vines_JE2_BE2.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Shears",
    version: "beta",
    color: "green"
}
export const WarpedButton: BlockType = {
    name: "warped_button",
    image: "https://minecraft.wiki/images/Warped_Button_JE2.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Any",
    version: "1.16",
    color: "cyan"
}
export const WarpedDoor: BlockType = {
    name: "warped_door",
    image: "https://minecraft.wiki/images/Warped_Door_JE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedFence: BlockType = {
    name: "warped_fence",
    image: "https://minecraft.wiki/images/Warped_Fence_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedFenceGate: BlockType = {
    name: "warped_fence_gate",
    image: "https://minecraft.wiki/images/Warped_Fence_Gate_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedFungus: BlockType = {
    name: "warped_fungus",
    image: "https://minecraft.wiki/images/Warped_Fungus_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.16",
    color: "cyan"
}
export const WarpedHangingSign: BlockType = {
    name: "warped_hanging_sign",
    image: "https://minecraft.wiki/images/Warped_Hanging_Sign_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.19.3",
    color: "cyan"
}
export const WarpedHyphae: BlockType = {
    name: "warped_hyphae",
    image: "https://minecraft.wiki/images/Warped_Hyphae_(UD)_JE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedNylium: BlockType = {
    name: "warped_nylium",
    image: "https://minecraft.wiki/images/Warped_Nylium_JE1_BE1.png",
    hardness: 0.4,
    blast_resistance: 0.4,
    tool: "Pickaxe",
    version: "1.16",
    color: "red"
}
export const WarpedPlanks: BlockType = {
    name: "warped_planks",
    image: "https://minecraft.wiki/images/Warped_Planks_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedPressurePlate: BlockType = {
    name: "warped_pressure_plate",
    image: "https://minecraft.wiki/images/Warped_Pressure_Plate_JE1_BE1.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedRoots: BlockType = {
    name: "warped_roots",
    image: "https://minecraft.wiki/images/Warped_Roots_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.16",
    color: "cyan"
}
export const WarpedSign: BlockType = {
    name: "warped_sign",
    image: "https://minecraft.wiki/images/Warped_Sign_(0).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedSlab: BlockType = {
    name: "warped_slab",
    image: "https://minecraft.wiki/images/Warped_Slab_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedStairs: BlockType = {
    name: "warped_stairs",
    image: "https://minecraft.wiki/images/Warped_Stairs_(N)_JE1_BE1.png",
    hardness: 2,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedStem: BlockType = {
    name: "warped_stem",
    image: "https://minecraft.wiki/images/Warped_Stem_(UD)_JE1.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedTrapdoor: BlockType = {
    name: "warped_trapdoor",
    image: "https://minecraft.wiki/images/Warped_Trapdoor_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Axe",
    version: "1.16",
    color: "cyan"
}
export const WarpedWartBlock: BlockType = {
    name: "warped_wart_block",
    image: "https://minecraft.wiki/images/Warped_Wart_Block_JE1_BE1.png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Hoe",
    version: "1.16",
    color: "cyan"
}
export const Water: BlockType = {
    name: "water",
    image: "https://minecraft.wiki/images/Water_JE16-a1.png",
    hardness: 100,
    blast_resistance: 100,
    tool: "Bucket",
    version: "classic",
    color: "blue"
}
export const WeatheredChiseledCopper: BlockType = {
    name: "weathered_chiseled_copper",
    image: "https://minecraft.wiki/images/Weathered_Chiseled_Copper_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "green"
}
export const WeatheredBlockOfCopper: BlockType = {
    name: "weathered_copper",
    image: "https://minecraft.wiki/images/Weathered_Copper_Block_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "green"
}
export const WeatheredCopperBulb: BlockType = {
    name: "weathered_copper_bulb",
    image: "https://minecraft.wiki/images/Weathered_Copper_Bulb_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "green"
}
export const WeatheredCopperDoor: BlockType = {
    name: "weathered_copper_door",
    image: "https://minecraft.wiki/images/Weathered_Copper_Door_JE3_BE3.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "green"
}
export const WeatheredCopperGrate: BlockType = {
    name: "weathered_copper_grate",
    image: "https://minecraft.wiki/images/Weathered_Copper_Grate_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "green"
}
export const WeatheredCopperTrapdoor: BlockType = {
    name: "weathered_copper_trapdoor",
    image: "https://minecraft.wiki/images/Weathered_Copper_Trapdoor_JE2_BE2.png",
    hardness: 3,
    blast_resistance: 3,
    tool: "Pickaxe",
    version: "1.20.3",
    color: "green"
}
export const WeatheredCutCopper: BlockType = {
    name: "weathered_cut_copper",
    image: "https://minecraft.wiki/images/Weathered_Cut_Copper_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "green"
}
export const WeatheredCutCopperSlab: BlockType = {
    name: "weathered_cut_copper_slab",
    image: "https://minecraft.wiki/images/Weathered_Cut_Copper_Slab_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "green"
}
export const WeatheredCutCopperStairs: BlockType = {
    name: "weathered_cut_copper_stairs",
    image: "https://minecraft.wiki/images/Weathered_Cut_Copper_Stairs_(N)_JE1_BE1.png",
    hardness: 3,
    blast_resistance: 6,
    tool: "Pickaxe",
    version: "1.17",
    color: "green"
}
export const WeepingVines: BlockType = {
    name: "weeping_vines",
    image: "https://minecraft.wiki/images/Weeping_Vines_Plant_JE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.16",
    color: "dark_red"
}
export const WetSponge: BlockType = {
    name: "wet_sponge",
    image: "https://minecraft.wiki/images/Wet_Sponge_JE2_BE2.png",
    hardness: 0.6,
    blast_resistance: 0.6,
    tool: "Hoe",
    version: "1.8",
    color: "yellow"
}
export const WheatCrop: BlockType = {
    name: "wheat_crop",
    image: "https://minecraft.wiki/images/Wheat_Age_7_JE10.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "None",
    version: "indev",
    color: "yellow"
}
export const WhiteBanner: BlockType = {
    name: "white_banner",
    image: "https://minecraft.wiki/images/White_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "white"
}
export const WhiteBed: BlockType = {
    name: "white_bed",
    image: "https://minecraft.wiki/images/White_Bed_(N).png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "white"
}
export const WhiteCandle: BlockType = {
    name: "white_candle",
    image: "https://minecraft.wiki/images/White_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "white"
}
export const WhiteCarpet: BlockType = {
    name: "white_carpet",
    image: "https://minecraft.wiki/images/White_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "white"
}
export const WhiteConcrete: BlockType = {
    name: "white_concrete",
    image: "https://minecraft.wiki/images/White_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "white"
}
export const WhiteConcretePowder: BlockType = {
    name: "white_concrete_powder",
    image: "https://minecraft.wiki/images/White_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "white"
}
export const WhiteGlazedTerracotta: BlockType = {
    name: "white_glazed_terracotta",
    image: "https://minecraft.wiki/images/White_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "white"
}
export const WhiteShulkerBox: BlockType = {
    name: "white_shulker_box",
    image: "https://minecraft.wiki/images/White_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "white"
}
export const WhiteStainedGlass: BlockType = {
    name: "white_stained_glass",
    image: "https://minecraft.wiki/images/White_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "white"
}
export const WhiteStainedGlassPane: BlockType = {
    name: "white_stained_glass_pane",
    image: "https://minecraft.wiki/images/White_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "white"
}
export const WhiteStainedTerracotta: BlockType = {
    name: "white_stained_terracotta",
    image: "https://minecraft.wiki/images/White_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "cream"
}
export const WhiteWool: BlockType = {
    name: "white_wool",
    image: "https://minecraft.wiki/images/White_Wool_JE2_BE2.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "white"
}
export const WhiteTulip: BlockType = {
    name: "white_tulip",
    image: "https://minecraft.wiki/images/Red_Tulip_JE7_BE2.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.7.2",
    color: "white"
}
export const WitherRose: BlockType = {
    name: "wither_rose",
    image: "https://minecraft.wiki/images/Wither_Rose_JE1_BE1.png",
    hardness: 0,
    blast_resistance: 0,
    tool: "Any",
    version: "1.14",
    color: "black"
}
export const WitherSkeletonSkull: BlockType = {
    name: "wither_skeleton_skull",
    image: "https://minecraft.wiki/images/Wither_Skeleton_Skull_(8).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Any",
    version: "1.4.2",
    color: "black"
}
export const YellowBanner: BlockType = {
    name: "yellow_banner",
    image: "https://minecraft.wiki/images/Yellow_Banner.gif",
    hardness: 1,
    blast_resistance: 1,
    tool: "Axe",
    version: "1.8",
    color: "yellow"
}
export const YellowBed: BlockType = {
    name: "yellow_bed",
    image: "https://minecraft.wiki/images/Yellow_Bed.png",
    hardness: 0.2,
    blast_resistance: 0.2,
    tool: "Any",
    version: "1.12",
    color: "yellow"
}
export const YellowCandle: BlockType = {
    name: "yellow_candle",
    image: "https://minecraft.wiki/images/Yellow_Candle.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.17",
    color: "yellow"
}
export const YellowCarpet: BlockType = {
    name: "yellow_carpet",
    image: "https://minecraft.wiki/images/Yellow_Carpet.png",
    hardness: 0.1,
    blast_resistance: 0.1,
    tool: "Any",
    version: "1.6.1",
    color: "yellow"
}
export const YellowConcrete: BlockType = {
    name: "yellow_concrete",
    image: "https://minecraft.wiki/images/Yellow_Concrete.png",
    hardness: 1.8,
    blast_resistance: 1.8,
    tool: "Pickaxe",
    version: "1.12",
    color: "yellow"
}
export const YellowConcretePowder: BlockType = {
    name: "yellow_concrete_powder",
    image: "https://minecraft.wiki/images/Yellow_Concrete_Powder.png",
    hardness: 0.5,
    blast_resistance: 0.5,
    tool: "Shovel",
    version: "1.12",
    color: "yellow"
}
export const YellowGlazedTerracotta: BlockType = {
    name: "yellow_glazed_terracotta",
    image: "https://minecraft.wiki/images/Yellow_Glazed_Terracotta_JE1_BE1.png",
    hardness: 1.4,
    blast_resistance: 1.4,
    tool: "Pickaxe",
    version: "1.12",
    color: "yellow"
}
export const YellowShulkerBox: BlockType = {
    name: "yellow_shulker_box",
    image: "https://minecraft.wiki/images/Yellow_Shulker_Box.png",
    hardness: 2,
    blast_resistance: 2,
    tool: "Pickaxe",
    version: "1.11",
    color: "yellow"
}
export const YellowStainedGlass: BlockType = {
    name: "yellow_stained_glass",
    image: "https://minecraft.wiki/images/Yellow_Stained_Glass_JE3_BE3.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "yellow"
}
export const YellowStainedGlassPane: BlockType = {
    name: "yellow_stained_glass_pane",
    image: "https://minecraft.wiki/images/Yellow_Stained_Glass_Pane_JE3_BE2.png",
    hardness: 0.3,
    blast_resistance: 0.3,
    tool: "Any",
    version: "1.7.2",
    color: "yellow"
}
export const YellowStainedTerracotta: BlockType = {
    name: "yellow_stained_terracotta",
    image: "https://minecraft.wiki/images/Yellow_Terracotta_JE1_BE1.png",
    hardness: 1.25,
    blast_resistance: 4.2,
    tool: "Pickaxe",
    version: "1.6.1",
    color: "yellow"
}
export const YellowWool: BlockType = {
    name: "yellow_wool",
    image: "https://minecraft.wiki/images/Yellow_Wool_JE3_BE3.png",
    hardness: 0.8,
    blast_resistance: 0.8,
    tool: "Shears",
    version: "beta",
    color: "yellow"
}
export const ZombieHead: BlockType = {
    name: "zombie_head",
    image: "https://minecraft.wiki/images/Zombie_Head_(8).png",
    hardness: 1,
    blast_resistance: 1,
    tool: "Any",
    version: "1.4.2",
    color: "green"
}








